//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import type { CancelTokenSource } from 'axios';
import type * as Axios from 'axios';
import Constants from 'expo-constants';
import { Platform } from 'react-native';
import { getDevelopmentApiHeaders } from './developmentHeaders';
import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ApiConfig {
  accessToken!: () => Promise<string>;
  customToken?: string;
  customCulture?: string;
}

export class BaseApi {
  public config: ApiConfig;

  constructor(config: ApiConfig) {
    this.config = config;
  }

  public commonConfig?: Axios.AxiosRequestConfig;
  public tokenSource!: CancelTokenSource;

  public isCancelled = false;
  public onCancel!: () => void;

  public setCustomToken = (token: string) => {
    this.config.customToken = token;
  };

  public setCustomCulture = (culture: string) => {
    this.config.customCulture = culture;
  };

  public cancelRequest = (cancelToken: CancelTokenSource) => {
    cancelToken.cancel();
    this.isCancelled = true;

    if (this.onCancel) {
      this.onCancel();
    }
  };

  public getBaseUrl = (generatedUrl: string) => {
    const configuredBaseUrl = Constants.expoConfig?.extra?.baseUrl;

    if (configuredBaseUrl) {
      return configuredBaseUrl;
    }

    return generatedUrl;
  };

  private normalizeNativeMultipartData = (options: Axios.AxiosRequestConfig<any>) => {
    if (Platform.OS === 'web' || !(options.data instanceof FormData)) {
      return;
    }

    const parts = (options.data as any)._parts;
    if (Array.isArray(parts)) {
      const normalizedContent = new FormData();

      parts.forEach(([fieldName, value]) => {
        if (value?.uri) {
          normalizedContent.append(fieldName, {
            uri: value.uri,
            name: value.name,
            type: value.type,
          } as any);
        } else {
          normalizedContent.append(fieldName, value);
        }
      });

      options.data = normalizedContent;
    }

    if (options.headers) {
      options.headers['Content-Type'] = 'multipart/form-data';
    }
  };

  // @ts-ignore Will be imported by nswag in the generated files
  protected async transformOptions(options: Axios.AxiosRequestConfig<any>) {
    Object.assign(options.headers ??= {}, getDevelopmentApiHeaders(options.url));
    let token = '';

    // If there is customToken, uses it instead of Firebase token
    if (this.config.customToken) {
      token = this.config.customToken;

      if (options.headers) {
        options.headers.authorization = `MSCustom ${token}`;

        if (this.config.customCulture) {
          options.headers['X-hexa-culture'] = this.config.customCulture;
        }
      }
    } else {
      token = await this.config.accessToken();

      if (options.headers) {
        options.headers.authorization = `Firebase ${token}`;

        if (this.config.customCulture) {
          options.headers['X-hexa-culture'] = this.config.customCulture;
        }
      }
    }

    this.normalizeNativeMultipartData(options);

    return Promise.resolve(options);
  }
}

export class AppReviewPromptClient extends BaseApi {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create(this.commonConfig);

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://api.hulk.cool");

    }

    getEligibility( cancelToken?: CancelToken): Promise<GetAppReviewPromptEligibilityViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/AppReviewPrompt/eligibility";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEligibility(_response);
        });
    }

    protected processGetEligibility(response: AxiosResponse): Promise<GetAppReviewPromptEligibilityViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAppReviewPromptEligibilityViewModel.fromJS(resultData200);
            return Promise.resolve<GetAppReviewPromptEligibilityViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAppReviewPromptEligibilityViewModel>(null as any);
    }

    markSeen(promptId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ms/client/AppReviewPrompt/{promptId}/seen";
        if (promptId === undefined || promptId === null)
            throw new globalThis.Error("The parameter 'promptId' must be defined.");
        url_ = url_.replace("{promptId}", encodeURIComponent("" + promptId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkSeen(_response);
        });
    }

    protected processMarkSeen(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: String(response.headers["content-type"] ?? "") }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    submitFeedback(promptId: string, request: SubmitAppReviewPromptFeedbackRequest, cancelToken?: CancelToken): Promise<AppReviewPromptActionViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/AppReviewPrompt/{promptId}/feedback";
        if (promptId === undefined || promptId === null)
            throw new globalThis.Error("The parameter 'promptId' must be defined.");
        url_ = url_.replace("{promptId}", encodeURIComponent("" + promptId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitFeedback(_response);
        });
    }

    protected processSubmitFeedback(response: AxiosResponse): Promise<AppReviewPromptActionViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppReviewPromptActionViewModel.fromJS(resultData200);
            return Promise.resolve<AppReviewPromptActionViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppReviewPromptActionViewModel>(null as any);
    }

    recordEvent(promptId: string, request: RecordAppReviewPromptEventRequest, cancelToken?: CancelToken): Promise<AppReviewPromptActionViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/AppReviewPrompt/{promptId}/event";
        if (promptId === undefined || promptId === null)
            throw new globalThis.Error("The parameter 'promptId' must be defined.");
        url_ = url_.replace("{promptId}", encodeURIComponent("" + promptId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecordEvent(_response);
        });
    }

    protected processRecordEvent(response: AxiosResponse): Promise<AppReviewPromptActionViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppReviewPromptActionViewModel.fromJS(resultData200);
            return Promise.resolve<AppReviewPromptActionViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppReviewPromptActionViewModel>(null as any);
    }
}

export class AuthenticateClient extends BaseApi {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create(this.commonConfig);

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://api.hulk.cool");

    }

    getMysteryShopperExists( cancelToken?: CancelToken): Promise<MysteryShopperExistsViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Authenticate/exists";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMysteryShopperExists(_response);
        });
    }

    protected processGetMysteryShopperExists(response: AxiosResponse): Promise<MysteryShopperExistsViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MysteryShopperExistsViewModel.fromJS(resultData200);
            return Promise.resolve<MysteryShopperExistsViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MysteryShopperExistsViewModel>(null as any);
    }

    registration(registration: RegistrationDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ms/client/Authenticate/registration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registration);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegistration(_response);
        });
    }

    protected processRegistration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    login( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ms/client/Authenticate/login";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    externalLogin(data: ExternalLoginRequest, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ms/client/Authenticate/external-login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalLogin(_response);
        });
    }

    protected processExternalLogin(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    externalExists(data: ExternalExistsRequest, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ms/client/Authenticate/external-exists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalExists(_response);
        });
    }

    protected processExternalExists(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class CampaignSignupClient extends BaseApi {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create(this.commonConfig);

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://api.hulk.cool");

    }

    getCampaignPartner(partnerId: string, cancelToken?: CancelToken): Promise<CampaignRedirectResponse> {
        let url_ = this.baseUrl + "/api/ms/client/CampaignSignup/partner/{partnerId}";
        if (partnerId === undefined || partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCampaignPartner(_response);
        });
    }

    protected processGetCampaignPartner(response: AxiosResponse): Promise<CampaignRedirectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CampaignRedirectResponse.fromJS(resultData200);
            return Promise.resolve<CampaignRedirectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CampaignRedirectResponse>(null as any);
    }

    registerCampaignSignup(partnerId: string, request: CampaignRegistrationRequest, cancelToken?: CancelToken): Promise<CampaignRedirectResponse> {
        let url_ = this.baseUrl + "/api/ms/client/CampaignSignup/registration/{partnerId}";
        if (partnerId === undefined || partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterCampaignSignup(_response);
        });
    }

    protected processRegisterCampaignSignup(response: AxiosResponse): Promise<CampaignRedirectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CampaignRedirectResponse.fromJS(resultData200);
            return Promise.resolve<CampaignRedirectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CampaignRedirectResponse>(null as any);
    }

    exchangeCampaignSignup(request: CampaignExchangeRequest, cancelToken?: CancelToken): Promise<CampaignExchangeResponse> {
        let url_ = this.baseUrl + "/api/ms/client/CampaignSignup/exchange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExchangeCampaignSignup(_response);
        });
    }

    protected processExchangeCampaignSignup(response: AxiosResponse): Promise<CampaignExchangeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CampaignExchangeResponse.fromJS(resultData200);
            return Promise.resolve<CampaignExchangeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CampaignExchangeResponse>(null as any);
    }

    requestCampaignSetupEmail(request: CampaignSetupEmailRequest, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ms/client/CampaignSignup/setup-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestCampaignSetupEmail(_response);
        });
    }

    protected processRequestCampaignSetupEmail(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    completeCampaignSetup(request: CompleteCampaignSetupRequest, cancelToken?: CancelToken): Promise<CompleteCampaignSetupResponse> {
        let url_ = this.baseUrl + "/api/ms/client/CampaignSignup/complete-setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompleteCampaignSetup(_response);
        });
    }

    protected processCompleteCampaignSetup(response: AxiosResponse): Promise<CompleteCampaignSetupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CompleteCampaignSetupResponse.fromJS(resultData200);
            return Promise.resolve<CompleteCampaignSetupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompleteCampaignSetupResponse>(null as any);
    }

    getCampaignSecurity( cancelToken?: CancelToken): Promise<CampaignSecurityResponse> {
        let url_ = this.baseUrl + "/api/ms/client/CampaignSignup/security";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCampaignSecurity(_response);
        });
    }

    protected processGetCampaignSecurity(response: AxiosResponse): Promise<CampaignSecurityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CampaignSecurityResponse.fromJS(resultData200);
            return Promise.resolve<CampaignSecurityResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CampaignSecurityResponse>(null as any);
    }
}

export class GlobalSettingsClient extends BaseApi {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create(this.commonConfig);

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://api.hulk.cool");

    }

    get( cancelToken?: CancelToken): Promise<GetClientGlobalSettingsResponse> {
        let url_ = this.baseUrl + "/api/ms/client/global-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<GetClientGlobalSettingsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetClientGlobalSettingsResponse.fromJS(resultData200);
            return Promise.resolve<GetClientGlobalSettingsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetClientGlobalSettingsResponse>(null as any);
    }
}

export class MissionsClient extends BaseApi {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create(this.commonConfig);

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://api.hulk.cool");

    }

    getMissionSurveyTemp(periodMissionConfigurationId: string, cancelToken?: CancelToken): Promise<GetSurveyFromTempViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/{periodMissionConfigurationId}/surveyTemp";
        if (periodMissionConfigurationId === undefined || periodMissionConfigurationId === null)
            throw new globalThis.Error("The parameter 'periodMissionConfigurationId' must be defined.");
        url_ = url_.replace("{periodMissionConfigurationId}", encodeURIComponent("" + periodMissionConfigurationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMissionSurveyTemp(_response);
        });
    }

    protected processGetMissionSurveyTemp(response: AxiosResponse): Promise<GetSurveyFromTempViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSurveyFromTempViewModel.fromJS(resultData200);
            return Promise.resolve<GetSurveyFromTempViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSurveyFromTempViewModel>(null as any);
    }

    getMissionDetails(branchId: string | undefined, location: string | null | undefined, onlyAcceptableMissions: boolean | undefined, searchDateTime: Date | null | undefined, periodMissionConfigurationIds: string[] | null | undefined, cancelToken?: CancelToken): Promise<GetMissionDetailsViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/details?";
        if (branchId === null)
            throw new globalThis.Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        if (location !== undefined && location !== null)
            url_ += "location=" + encodeURIComponent("" + location) + "&";
        if (onlyAcceptableMissions === null)
            throw new globalThis.Error("The parameter 'onlyAcceptableMissions' cannot be null.");
        else if (onlyAcceptableMissions !== undefined)
            url_ += "onlyAcceptableMissions=" + encodeURIComponent("" + onlyAcceptableMissions) + "&";
        if (searchDateTime !== undefined && searchDateTime !== null)
            url_ += "searchDateTime=" + encodeURIComponent(searchDateTime ? "" + searchDateTime.toISOString() : "") + "&";
        if (periodMissionConfigurationIds !== undefined && periodMissionConfigurationIds !== null)
            periodMissionConfigurationIds && periodMissionConfigurationIds.forEach(item => { url_ += "periodMissionConfigurationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMissionDetails(_response);
        });
    }

    protected processGetMissionDetails(response: AxiosResponse): Promise<GetMissionDetailsViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMissionDetailsViewModel.fromJS(resultData200);
            return Promise.resolve<GetMissionDetailsViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMissionDetailsViewModel>(null as any);
    }

    getRemoteMissions(tagIds: string[] | null | undefined, cancelToken?: CancelToken): Promise<RemoteMissionSummaryDto[]> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/remote?";
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "tagIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRemoteMissions(_response);
        });
    }

    protected processGetRemoteMissions(response: AxiosResponse): Promise<RemoteMissionSummaryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RemoteMissionSummaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<RemoteMissionSummaryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RemoteMissionSummaryDto[]>(null as any);
    }

    getRemoteMissionDetails(periodMissionConfigurationId: string, cancelToken?: CancelToken): Promise<GetRemoteMissionDetailsResponse> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/remote/{periodMissionConfigurationId}";
        if (periodMissionConfigurationId === undefined || periodMissionConfigurationId === null)
            throw new globalThis.Error("The parameter 'periodMissionConfigurationId' must be defined.");
        url_ = url_.replace("{periodMissionConfigurationId}", encodeURIComponent("" + periodMissionConfigurationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRemoteMissionDetails(_response);
        });
    }

    protected processGetRemoteMissionDetails(response: AxiosResponse): Promise<GetRemoteMissionDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRemoteMissionDetailsResponse.fromJS(resultData200);
            return Promise.resolve<GetRemoteMissionDetailsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRemoteMissionDetailsResponse>(null as any);
    }

    getRemoteMissionEligibility(periodMissionConfigurationId: string, branchId: string | null | undefined, cancelToken?: CancelToken): Promise<GetRemoteMissionEligibilityResponse> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/remote/{periodMissionConfigurationId}/eligibility?";
        if (periodMissionConfigurationId === undefined || periodMissionConfigurationId === null)
            throw new globalThis.Error("The parameter 'periodMissionConfigurationId' must be defined.");
        url_ = url_.replace("{periodMissionConfigurationId}", encodeURIComponent("" + periodMissionConfigurationId));
        if (branchId !== undefined && branchId !== null)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRemoteMissionEligibility(_response);
        });
    }

    protected processGetRemoteMissionEligibility(response: AxiosResponse): Promise<GetRemoteMissionEligibilityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRemoteMissionEligibilityResponse.fromJS(resultData200);
            return Promise.resolve<GetRemoteMissionEligibilityResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRemoteMissionEligibilityResponse>(null as any);
    }

    acceptRemoteMission(periodMissionConfigurationId: string, request: AcceptRemoteMissionRequest, cancelToken?: CancelToken): Promise<AcceptRemoteMissionResponse> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/remote/{periodMissionConfigurationId}/accept";
        if (periodMissionConfigurationId === undefined || periodMissionConfigurationId === null)
            throw new globalThis.Error("The parameter 'periodMissionConfigurationId' must be defined.");
        url_ = url_.replace("{periodMissionConfigurationId}", encodeURIComponent("" + periodMissionConfigurationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptRemoteMission(_response);
        });
    }

    protected processAcceptRemoteMission(response: AxiosResponse): Promise<AcceptRemoteMissionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AcceptRemoteMissionResponse.fromJS(resultData200);
            return Promise.resolve<AcceptRemoteMissionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AcceptRemoteMissionResponse>(null as any);
    }

    getAirportZones( cancelToken?: CancelToken): Promise<GetAirportMissionZonesViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/airport/zones";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAirportZones(_response);
        });
    }

    protected processGetAirportZones(response: AxiosResponse): Promise<GetAirportMissionZonesViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAirportMissionZonesViewModel.fromJS(resultData200);
            return Promise.resolve<GetAirportMissionZonesViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAirportMissionZonesViewModel>(null as any);
    }

    getAirportMissions(destinationZoneId: string | null | undefined, connectionZoneId: string | null | undefined, searchDateTime: string | null | undefined, airportVisitType: AirportVisitType | null | undefined, tagIds: string[] | null | undefined, onlyAcceptableMissions: boolean | null | undefined, showUpcomingMissions: boolean | null | undefined, cancelToken?: CancelToken): Promise<GetMissionsViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/airport?";
        if (destinationZoneId !== undefined && destinationZoneId !== null)
            url_ += "destinationZoneId=" + encodeURIComponent("" + destinationZoneId) + "&";
        if (connectionZoneId !== undefined && connectionZoneId !== null)
            url_ += "connectionZoneId=" + encodeURIComponent("" + connectionZoneId) + "&";
        if (searchDateTime !== undefined && searchDateTime !== null)
            url_ += "searchDateTime=" + encodeURIComponent("" + searchDateTime) + "&";
        if (airportVisitType !== undefined && airportVisitType !== null)
            url_ += "airportVisitType=" + encodeURIComponent("" + airportVisitType) + "&";
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "tagIds=" + encodeURIComponent("" + item) + "&"; });
        if (onlyAcceptableMissions !== undefined && onlyAcceptableMissions !== null)
            url_ += "onlyAcceptableMissions=" + encodeURIComponent("" + onlyAcceptableMissions) + "&";
        if (showUpcomingMissions !== undefined && showUpcomingMissions !== null)
            url_ += "showUpcomingMissions=" + encodeURIComponent("" + showUpcomingMissions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAirportMissions(_response);
        });
    }

    protected processGetAirportMissions(response: AxiosResponse): Promise<GetMissionsViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMissionsViewModel.fromJS(resultData200);
            return Promise.resolve<GetMissionsViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMissionsViewModel>(null as any);
    }

    getMissionsFromMap(tagIds: string[] | null | undefined, location: string, bottomRightLocation: string | undefined, topLeftLocation: string | undefined, onlyAcceptableMissions: boolean | undefined, cancelToken?: CancelToken): Promise<GetMissionsFromMapResponse> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/map/{location}?";
        if (location === undefined || location === null)
            throw new globalThis.Error("The parameter 'location' must be defined.");
        url_ = url_.replace("{location}", encodeURIComponent("" + location));
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "tagIds=" + encodeURIComponent("" + item) + "&"; });
        if (bottomRightLocation === null)
            throw new globalThis.Error("The parameter 'bottomRightLocation' cannot be null.");
        else if (bottomRightLocation !== undefined)
            url_ += "bottomRightLocation=" + encodeURIComponent("" + bottomRightLocation) + "&";
        if (topLeftLocation === null)
            throw new globalThis.Error("The parameter 'topLeftLocation' cannot be null.");
        else if (topLeftLocation !== undefined)
            url_ += "topLeftLocation=" + encodeURIComponent("" + topLeftLocation) + "&";
        if (onlyAcceptableMissions === null)
            throw new globalThis.Error("The parameter 'onlyAcceptableMissions' cannot be null.");
        else if (onlyAcceptableMissions !== undefined)
            url_ += "onlyAcceptableMissions=" + encodeURIComponent("" + onlyAcceptableMissions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMissionsFromMap(_response);
        });
    }

    protected processGetMissionsFromMap(response: AxiosResponse): Promise<GetMissionsFromMapResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMissionsFromMapResponse.fromJS(resultData200);
            return Promise.resolve<GetMissionsFromMapResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMissionsFromMapResponse>(null as any);
    }

    getMissionsFromMapv2(tagIds: string[] | null | undefined, location: string, bottomRightLocation: string | null | undefined, topLeftLocation: string | null | undefined, onlyAcceptableMissions: boolean | undefined, showUpcomingMissions: boolean | undefined, splitCurrentAndUpcoming: boolean | undefined, mapCenterLocation: string | null | undefined, cancelToken?: CancelToken): Promise<GetMissionsFromMapResponse> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/map/{location}/v2?";
        if (location === undefined || location === null)
            throw new globalThis.Error("The parameter 'location' must be defined.");
        url_ = url_.replace("{location}", encodeURIComponent("" + location));
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "tagIds=" + encodeURIComponent("" + item) + "&"; });
        if (bottomRightLocation !== undefined && bottomRightLocation !== null)
            url_ += "bottomRightLocation=" + encodeURIComponent("" + bottomRightLocation) + "&";
        if (topLeftLocation !== undefined && topLeftLocation !== null)
            url_ += "topLeftLocation=" + encodeURIComponent("" + topLeftLocation) + "&";
        if (onlyAcceptableMissions === null)
            throw new globalThis.Error("The parameter 'onlyAcceptableMissions' cannot be null.");
        else if (onlyAcceptableMissions !== undefined)
            url_ += "onlyAcceptableMissions=" + encodeURIComponent("" + onlyAcceptableMissions) + "&";
        if (showUpcomingMissions === null)
            throw new globalThis.Error("The parameter 'showUpcomingMissions' cannot be null.");
        else if (showUpcomingMissions !== undefined)
            url_ += "showUpcomingMissions=" + encodeURIComponent("" + showUpcomingMissions) + "&";
        if (splitCurrentAndUpcoming === null)
            throw new globalThis.Error("The parameter 'splitCurrentAndUpcoming' cannot be null.");
        else if (splitCurrentAndUpcoming !== undefined)
            url_ += "splitCurrentAndUpcoming=" + encodeURIComponent("" + splitCurrentAndUpcoming) + "&";
        if (mapCenterLocation !== undefined && mapCenterLocation !== null)
            url_ += "mapCenterLocation=" + encodeURIComponent("" + mapCenterLocation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMissionsFromMapv2(_response);
        });
    }

    protected processGetMissionsFromMapv2(response: AxiosResponse): Promise<GetMissionsFromMapResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMissionsFromMapResponse.fromJS(resultData200);
            return Promise.resolve<GetMissionsFromMapResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMissionsFromMapResponse>(null as any);
    }

    getAirportMissionsFromMapV2(tagIds: string[] | null | undefined, bottomRightLocation: string | undefined, topLeftLocation: string | undefined, location: string, onlyAcceptableMissions: boolean | undefined, showUpcomingMissions: boolean | undefined, mapCenterLocation: string | null | undefined, cancelToken?: CancelToken): Promise<GetAirportMissionsFromMapResponse> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/map/{location}/v2/airport?";
        if (location === undefined || location === null)
            throw new globalThis.Error("The parameter 'location' must be defined.");
        url_ = url_.replace("{location}", encodeURIComponent("" + location));
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "tagIds=" + encodeURIComponent("" + item) + "&"; });
        if (bottomRightLocation === null)
            throw new globalThis.Error("The parameter 'bottomRightLocation' cannot be null.");
        else if (bottomRightLocation !== undefined)
            url_ += "bottomRightLocation=" + encodeURIComponent("" + bottomRightLocation) + "&";
        if (topLeftLocation === null)
            throw new globalThis.Error("The parameter 'topLeftLocation' cannot be null.");
        else if (topLeftLocation !== undefined)
            url_ += "topLeftLocation=" + encodeURIComponent("" + topLeftLocation) + "&";
        if (onlyAcceptableMissions === null)
            throw new globalThis.Error("The parameter 'onlyAcceptableMissions' cannot be null.");
        else if (onlyAcceptableMissions !== undefined)
            url_ += "onlyAcceptableMissions=" + encodeURIComponent("" + onlyAcceptableMissions) + "&";
        if (showUpcomingMissions === null)
            throw new globalThis.Error("The parameter 'showUpcomingMissions' cannot be null.");
        else if (showUpcomingMissions !== undefined)
            url_ += "showUpcomingMissions=" + encodeURIComponent("" + showUpcomingMissions) + "&";
        if (mapCenterLocation !== undefined && mapCenterLocation !== null)
            url_ += "mapCenterLocation=" + encodeURIComponent("" + mapCenterLocation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAirportMissionsFromMapV2(_response);
        });
    }

    protected processGetAirportMissionsFromMapV2(response: AxiosResponse): Promise<GetAirportMissionsFromMapResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAirportMissionsFromMapResponse.fromJS(resultData200);
            return Promise.resolve<GetAirportMissionsFromMapResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAirportMissionsFromMapResponse>(null as any);
    }

    getAcceptMissionsFromMap(brandIds: string[], cancelToken?: CancelToken): Promise<GetAcceptMissionsFromMapViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/map/accept";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(brandIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAcceptMissionsFromMap(_response);
        });
    }

    protected processGetAcceptMissionsFromMap(response: AxiosResponse): Promise<GetAcceptMissionsFromMapViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAcceptMissionsFromMapViewModel.fromJS(resultData200);
            return Promise.resolve<GetAcceptMissionsFromMapViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAcceptMissionsFromMapViewModel>(null as any);
    }

    getAcceptMission(periodMissionConfigurationId: string | undefined, branchId: string | undefined, cancelToken?: CancelToken): Promise<GetAcceptMissionViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/accept?";
        if (periodMissionConfigurationId === null)
            throw new globalThis.Error("The parameter 'periodMissionConfigurationId' cannot be null.");
        else if (periodMissionConfigurationId !== undefined)
            url_ += "periodMissionConfigurationId=" + encodeURIComponent("" + periodMissionConfigurationId) + "&";
        if (branchId === null)
            throw new globalThis.Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAcceptMission(_response);
        });
    }

    protected processGetAcceptMission(response: AxiosResponse): Promise<GetAcceptMissionViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAcceptMissionViewModel.fromJS(resultData200);
            return Promise.resolve<GetAcceptMissionViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAcceptMissionViewModel>(null as any);
    }

    acceptMission(periodMissionConfigurationId: string | undefined, branchId: string | undefined, startDate: Date | null | undefined, selectedRelatedMinorId: string | null | undefined, scenarioReviewCompleted: boolean | undefined, cancelToken?: CancelToken): Promise<AcceptMissionResponse> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/accept?";
        if (periodMissionConfigurationId === null)
            throw new globalThis.Error("The parameter 'periodMissionConfigurationId' cannot be null.");
        else if (periodMissionConfigurationId !== undefined)
            url_ += "periodMissionConfigurationId=" + encodeURIComponent("" + periodMissionConfigurationId) + "&";
        if (branchId === null)
            throw new globalThis.Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (selectedRelatedMinorId !== undefined && selectedRelatedMinorId !== null)
            url_ += "selectedRelatedMinorId=" + encodeURIComponent("" + selectedRelatedMinorId) + "&";
        if (scenarioReviewCompleted === null)
            throw new globalThis.Error("The parameter 'scenarioReviewCompleted' cannot be null.");
        else if (scenarioReviewCompleted !== undefined)
            url_ += "scenarioReviewCompleted=" + encodeURIComponent("" + scenarioReviewCompleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptMission(_response);
        });
    }

    protected processAcceptMission(response: AxiosResponse): Promise<AcceptMissionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AcceptMissionResponse.fromJS(resultData200);
            return Promise.resolve<AcceptMissionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AcceptMissionResponse>(null as any);
    }

    getAcceptMissions(branchId: string | undefined, periodMissionConfigurationIds: string[] | null | undefined, cancelToken?: CancelToken): Promise<GetAcceptMissionByBranchViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/accept-by-branch?";
        if (branchId === null)
            throw new globalThis.Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        if (periodMissionConfigurationIds !== undefined && periodMissionConfigurationIds !== null)
            periodMissionConfigurationIds && periodMissionConfigurationIds.forEach(item => { url_ += "periodMissionConfigurationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAcceptMissions(_response);
        });
    }

    protected processGetAcceptMissions(response: AxiosResponse): Promise<GetAcceptMissionByBranchViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAcceptMissionByBranchViewModel.fromJS(resultData200);
            return Promise.resolve<GetAcceptMissionByBranchViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAcceptMissionByBranchViewModel>(null as any);
    }

    createMissionReferral(request: CreateMissionReferralRequest, cancelToken?: CancelToken): Promise<CreateMissionReferralResponse> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/referrals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMissionReferral(_response);
        });
    }

    protected processCreateMissionReferral(response: AxiosResponse): Promise<CreateMissionReferralResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateMissionReferralResponse.fromJS(resultData200);
            return Promise.resolve<CreateMissionReferralResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateMissionReferralResponse>(null as any);
    }

    getMissionReferralList( cancelToken?: CancelToken): Promise<GetMissionReferralListResponse> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/referrals";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMissionReferralList(_response);
        });
    }

    protected processGetMissionReferralList(response: AxiosResponse): Promise<GetMissionReferralListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMissionReferralListResponse.fromJS(resultData200);
            return Promise.resolve<GetMissionReferralListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMissionReferralListResponse>(null as any);
    }

    getMissionReferralDetails(missionReferralId: string, cancelToken?: CancelToken): Promise<GetMissionReferralDetailsResponse> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/referrals/{missionReferralId}/details";
        if (missionReferralId === undefined || missionReferralId === null)
            throw new globalThis.Error("The parameter 'missionReferralId' must be defined.");
        url_ = url_.replace("{missionReferralId}", encodeURIComponent("" + missionReferralId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMissionReferralDetails(_response);
        });
    }

    protected processGetMissionReferralDetails(response: AxiosResponse): Promise<GetMissionReferralDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMissionReferralDetailsResponse.fromJS(resultData200);
            return Promise.resolve<GetMissionReferralDetailsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMissionReferralDetailsResponse>(null as any);
    }

    getMissionReferral(token: string, cancelToken?: CancelToken): Promise<GetMissionReferralResponse> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/referrals/{token}";
        if (token === undefined || token === null)
            throw new globalThis.Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMissionReferral(_response);
        });
    }

    protected processGetMissionReferral(response: AxiosResponse): Promise<GetMissionReferralResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMissionReferralResponse.fromJS(resultData200);
            return Promise.resolve<GetMissionReferralResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMissionReferralResponse>(null as any);
    }

    getMissionReferralAcceptability(token: string, cancelToken?: CancelToken): Promise<GetMissionReferralAcceptabilityResponse> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/referrals/{token}/acceptability";
        if (token === undefined || token === null)
            throw new globalThis.Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMissionReferralAcceptability(_response);
        });
    }

    protected processGetMissionReferralAcceptability(response: AxiosResponse): Promise<GetMissionReferralAcceptabilityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMissionReferralAcceptabilityResponse.fromJS(resultData200);
            return Promise.resolve<GetMissionReferralAcceptabilityResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMissionReferralAcceptabilityResponse>(null as any);
    }

    acceptMissionReferral(token: string, request: AcceptMissionReferralRequest | undefined, cancelToken?: CancelToken): Promise<AcceptMissionReferralResponse> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/referrals/{token}/accept";
        if (token === undefined || token === null)
            throw new globalThis.Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptMissionReferral(_response);
        });
    }

    protected processAcceptMissionReferral(response: AxiosResponse): Promise<AcceptMissionReferralResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AcceptMissionReferralResponse.fromJS(resultData200);
            return Promise.resolve<AcceptMissionReferralResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AcceptMissionReferralResponse>(null as any);
    }

    cancelMissionReferral(missionReferralId: string, cancelToken?: CancelToken): Promise<CancelMissionReferralResponse> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/referrals/{missionReferralId}";
        if (missionReferralId === undefined || missionReferralId === null)
            throw new globalThis.Error("The parameter 'missionReferralId' must be defined.");
        url_ = url_.replace("{missionReferralId}", encodeURIComponent("" + missionReferralId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelMissionReferral(_response);
        });
    }

    protected processCancelMissionReferral(response: AxiosResponse): Promise<CancelMissionReferralResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CancelMissionReferralResponse.fromJS(resultData200);
            return Promise.resolve<CancelMissionReferralResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CancelMissionReferralResponse>(null as any);
    }

    sendMissionReferralEmail(missionReferralId: string, request: SendMissionReferralEmailRequest, cancelToken?: CancelToken): Promise<SendMissionReferralEmailResponse> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/referrals/{missionReferralId}/email";
        if (missionReferralId === undefined || missionReferralId === null)
            throw new globalThis.Error("The parameter 'missionReferralId' must be defined.");
        url_ = url_.replace("{missionReferralId}", encodeURIComponent("" + missionReferralId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendMissionReferralEmail(_response);
        });
    }

    protected processSendMissionReferralEmail(response: AxiosResponse): Promise<SendMissionReferralEmailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendMissionReferralEmailResponse.fromJS(resultData200);
            return Promise.resolve<SendMissionReferralEmailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendMissionReferralEmailResponse>(null as any);
    }
}

export class MyMissionClient extends BaseApi {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create(this.commonConfig);

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://api.hulk.cool");

    }

    checkIn(missionAssignationId: string, request: MissionGeolocationCheckInRequest, cancelToken?: CancelToken): Promise<MissionGeolocationCheckInResult> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/{missionAssignationId}/check-in";
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new globalThis.Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckIn(_response);
        });
    }

    protected processCheckIn(response: AxiosResponse): Promise<MissionGeolocationCheckInResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MissionGeolocationCheckInResult.fromJS(resultData200);
            return Promise.resolve<MissionGeolocationCheckInResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MissionGeolocationCheckInResult>(null as any);
    }

    saveAndComplete(missionAssignationId: string, timeZoneOffset: number | null | undefined, data: SaveMissionAnswerDto[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/{missionAssignationId}?";
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new globalThis.Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        if (timeZoneOffset !== undefined && timeZoneOffset !== null)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveAndComplete(_response);
        });
    }

    protected processSaveAndComplete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    save(missionAssignationId: string, timeZoneOffset: number | null | undefined, data: PartialSaveMissionAnswerRequest[], cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/{missionAssignationId}?";
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new globalThis.Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        if (timeZoneOffset !== undefined && timeZoneOffset !== null)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getMissionSurvey(missionAssignationId: string, cancelToken?: CancelToken): Promise<GetSurveyFromMissionAssignationViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/{missionAssignationId}/survey";
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new globalThis.Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMissionSurvey(_response);
        });
    }

    protected processGetMissionSurvey(response: AxiosResponse): Promise<GetSurveyFromMissionAssignationViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSurveyFromMissionAssignationViewModel.fromJS(resultData200);
            return Promise.resolve<GetSurveyFromMissionAssignationViewModel>(result200);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSurveyFromMissionAssignationViewModel>(null as any);
    }

    cancelMyMission(missionAssignationId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/{missionAssignationId}/cancel";
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new globalThis.Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelMyMission(_response);
        });
    }

    protected processCancelMyMission(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    submitForCorrection(missionAssignationId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/{missionAssignationId}/submit";
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new globalThis.Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitForCorrection(_response);
        });
    }

    protected processSubmitForCorrection(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    extendMyMission(missionAssignationId: string, requestDay: number | undefined, cancelToken?: CancelToken): Promise<Date> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/{missionAssignationId}/extend?";
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new globalThis.Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        if (requestDay === null)
            throw new globalThis.Error("The parameter 'requestDay' cannot be null.");
        else if (requestDay !== undefined)
            url_ += "requestDay=" + encodeURIComponent("" + requestDay) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExtendMyMission(_response);
        });
    }

    protected processExtendMyMission(response: AxiosResponse): Promise<Date> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 ? new Date(resultData200.toString()) : null as any;

            return Promise.resolve<Date>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Date>(null as any);
    }

    getMyMissionExtendibleDays(missionAssignationId: string, cancelToken?: CancelToken): Promise<GetMyMissionExtendibleDaysViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/{missionAssignationId}/extendible-days";
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new globalThis.Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyMissionExtendibleDays(_response);
        });
    }

    protected processGetMyMissionExtendibleDays(response: AxiosResponse): Promise<GetMyMissionExtendibleDaysViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMyMissionExtendibleDaysViewModel.fromJS(resultData200);
            return Promise.resolve<GetMyMissionExtendibleDaysViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMyMissionExtendibleDaysViewModel>(null as any);
    }

    getMissionsList( cancelToken?: CancelToken): Promise<GetMyMissionListViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/missions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMissionsList(_response);
        });
    }

    protected processGetMissionsList(response: AxiosResponse): Promise<GetMyMissionListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMyMissionListViewModel.fromJS(resultData200);
            return Promise.resolve<GetMyMissionListViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMyMissionListViewModel>(null as any);
    }

    getCompetitorCircuit(competitorCircuitId: string, cancelToken?: CancelToken): Promise<CompetitorCircuitDetailsResponse> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/competitor-circuits/{competitorCircuitId}";
        if (competitorCircuitId === undefined || competitorCircuitId === null)
            throw new globalThis.Error("The parameter 'competitorCircuitId' must be defined.");
        url_ = url_.replace("{competitorCircuitId}", encodeURIComponent("" + competitorCircuitId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetitorCircuit(_response);
        });
    }

    protected processGetCompetitorCircuit(response: AxiosResponse): Promise<CompetitorCircuitDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CompetitorCircuitDetailsResponse.fromJS(resultData200);
            return Promise.resolve<CompetitorCircuitDetailsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompetitorCircuitDetailsResponse>(null as any);
    }

    getAirportTakenCount( cancelToken?: CancelToken): Promise<GetAirportTakenCountViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/airport/taken-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAirportTakenCount(_response);
        });
    }

    protected processGetAirportTakenCount(response: AxiosResponse): Promise<GetAirportTakenCountViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAirportTakenCountViewModel.fromJS(resultData200);
            return Promise.resolve<GetAirportTakenCountViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAirportTakenCountViewModel>(null as any);
    }

    getMissionDetails(missionAssignationId: string, cancelToken?: CancelToken): Promise<GetMyMissionDetailsViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/missions/{missionAssignationId}/details";
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new globalThis.Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMissionDetails(_response);
        });
    }

    protected processGetMissionDetails(response: AxiosResponse): Promise<GetMyMissionDetailsViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMyMissionDetailsViewModel.fromJS(resultData200);
            return Promise.resolve<GetMyMissionDetailsViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMyMissionDetailsViewModel>(null as any);
    }

    getPreValidation(missionAssignationId: string, cancelToken?: CancelToken): Promise<GetPreValidationResponse> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/missions/{missionAssignationId}/pre-validation";
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new globalThis.Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPreValidation(_response);
        });
    }

    protected processGetPreValidation(response: AxiosResponse): Promise<GetPreValidationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPreValidationResponse.fromJS(resultData200);
            return Promise.resolve<GetPreValidationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPreValidationResponse>(null as any);
    }

    getFailedValidationNotification( cancelToken?: CancelToken): Promise<GetFailedValidationNotificationViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/missions/failed-validation-notification";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFailedValidationNotification(_response);
        });
    }

    protected processGetFailedValidationNotification(response: AxiosResponse): Promise<GetFailedValidationNotificationViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFailedValidationNotificationViewModel.fromJS(resultData200);
            return Promise.resolve<GetFailedValidationNotificationViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFailedValidationNotificationViewModel>(null as any);
    }
}

export class MyRewardsClient extends BaseApi {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create(this.commonConfig);

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://api.hulk.cool");

    }

    getMyRewards( cancelToken?: CancelToken): Promise<GetMyRewardsViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MyRewards";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyRewards(_response);
        });
    }

    protected processGetMyRewards(response: AxiosResponse): Promise<GetMyRewardsViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMyRewardsViewModel.fromJS(resultData200);
            return Promise.resolve<GetMyRewardsViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMyRewardsViewModel>(null as any);
    }
}

export class MysteryShopperClient extends BaseApi {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create(this.commonConfig);

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://api.hulk.cool");

    }

    getProfile( cancelToken?: CancelToken): Promise<GetMysteryShopperProfileViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProfile(_response);
        });
    }

    protected processGetProfile(response: AxiosResponse): Promise<GetMysteryShopperProfileViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMysteryShopperProfileViewModel.fromJS(resultData200);
            return Promise.resolve<GetMysteryShopperProfileViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMysteryShopperProfileViewModel>(null as any);
    }

    verifyAccount( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/verify";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyAccount(_response);
        });
    }

    protected processVerifyAccount(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getIdVerification( cancelToken?: CancelToken): Promise<MysteryShopperVerificationStatusViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/id-verification";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIdVerification(_response);
        });
    }

    protected processGetIdVerification(response: AxiosResponse): Promise<MysteryShopperVerificationStatusViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MysteryShopperVerificationStatusViewModel.fromJS(resultData200);
            return Promise.resolve<MysteryShopperVerificationStatusViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MysteryShopperVerificationStatusViewModel>(null as any);
    }

    uploadIdVerification(frontDocument: FileParameter | null | undefined, backDocument: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<AdultIdVerificationDto> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/id-verification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (frontDocument !== null && frontDocument !== undefined)
            content_.append("FrontDocument", frontDocument.data, frontDocument.fileName ? frontDocument.fileName : "FrontDocument");
        if (backDocument !== null && backDocument !== undefined)
            content_.append("BackDocument", backDocument.data, backDocument.fileName ? backDocument.fileName : "BackDocument");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadIdVerification(_response);
        });
    }

    protected processUploadIdVerification(response: AxiosResponse): Promise<AdultIdVerificationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AdultIdVerificationDto.fromJS(resultData200);
            return Promise.resolve<AdultIdVerificationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdultIdVerificationDto>(null as any);
    }

    submitRelatedMinors(relatedMinorIds: string[] | null | undefined, firstNames: string[] | null | undefined, lastNames: string[] | null | undefined, genders: string[] | null | undefined, birthDates: string[] | null | undefined, relationships: string[] | null | undefined, frontDocuments: FileParameter[] | null | undefined, backDocuments: FileParameter[] | null | undefined, photoDocuments: FileParameter[] | null | undefined, cancelToken?: CancelToken): Promise<MysteryShopperVerificationStatusViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/related-minors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (relatedMinorIds !== null && relatedMinorIds !== undefined)
            relatedMinorIds.forEach(item_ => content_.append("relatedMinorIds", item_.toString()));
        if (firstNames !== null && firstNames !== undefined)
            firstNames.forEach(item_ => content_.append("firstNames", item_.toString()));
        if (lastNames !== null && lastNames !== undefined)
            lastNames.forEach(item_ => content_.append("lastNames", item_.toString()));
        if (genders !== null && genders !== undefined)
            genders.forEach(item_ => content_.append("genders", item_.toString()));
        if (birthDates !== null && birthDates !== undefined)
            birthDates.forEach(item_ => content_.append("birthDates", item_.toString()));
        if (relationships !== null && relationships !== undefined)
            relationships.forEach(item_ => content_.append("relationships", item_.toString()));
        if (frontDocuments !== null && frontDocuments !== undefined)
            frontDocuments.forEach(item_ => content_.append("frontDocuments", item_.data, item_.fileName ? item_.fileName : "frontDocuments") );
        if (backDocuments !== null && backDocuments !== undefined)
            backDocuments.forEach(item_ => content_.append("backDocuments", item_.data, item_.fileName ? item_.fileName : "backDocuments") );
        if (photoDocuments !== null && photoDocuments !== undefined)
            photoDocuments.forEach(item_ => content_.append("photoDocuments", item_.data, item_.fileName ? item_.fileName : "photoDocuments") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitRelatedMinors(_response);
        });
    }

    protected processSubmitRelatedMinors(response: AxiosResponse): Promise<MysteryShopperVerificationStatusViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MysteryShopperVerificationStatusViewModel.fromJS(resultData200);
            return Promise.resolve<MysteryShopperVerificationStatusViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MysteryShopperVerificationStatusViewModel>(null as any);
    }

    deleteRelatedMinor(relatedMinorId: string, cancelToken?: CancelToken): Promise<MysteryShopperVerificationStatusViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/related-minors/{relatedMinorId}";
        if (relatedMinorId === undefined || relatedMinorId === null)
            throw new globalThis.Error("The parameter 'relatedMinorId' must be defined.");
        url_ = url_.replace("{relatedMinorId}", encodeURIComponent("" + relatedMinorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRelatedMinor(_response);
        });
    }

    protected processDeleteRelatedMinor(response: AxiosResponse): Promise<MysteryShopperVerificationStatusViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MysteryShopperVerificationStatusViewModel.fromJS(resultData200);
            return Promise.resolve<MysteryShopperVerificationStatusViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MysteryShopperVerificationStatusViewModel>(null as any);
    }

    validateAddress(model: PostalAddressDto, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/validateaddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateAddress(_response);
        });
    }

    protected processValidateAddress(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    geocodeAddress(model: GeocodeAddressCommandDto, cancelToken?: CancelToken): Promise<GeocodeAddressCommandViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/geocodeaddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGeocodeAddress(_response);
        });
    }

    protected processGeocodeAddress(response: AxiosResponse): Promise<GeocodeAddressCommandViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GeocodeAddressCommandViewModel.fromJS(resultData200);
            return Promise.resolve<GeocodeAddressCommandViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeocodeAddressCommandViewModel>(null as any);
    }

    saveProfile(model: SaveProfileValueDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/profile/value";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveProfile(_response);
        });
    }

    protected processSaveProfile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    saveBasicInformation(model: SaveBasicInformationDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/profile/basicInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveBasicInformation(_response);
        });
    }

    protected processSaveBasicInformation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addAddress(model: MysteryShopperAddressDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/profile/addresses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddAddress(_response);
        });
    }

    protected processAddAddress(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateAddress(addressId: string, model: MysteryShopperAddressDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/profile/addresses/{addressId}";
        if (addressId === undefined || addressId === null)
            throw new globalThis.Error("The parameter 'addressId' must be defined.");
        url_ = url_.replace("{addressId}", encodeURIComponent("" + addressId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAddress(_response);
        });
    }

    protected processUpdateAddress(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteAddress(addressId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/profile/addresses/{addressId}";
        if (addressId === undefined || addressId === null)
            throw new globalThis.Error("The parameter 'addressId' must be defined.");
        url_ = url_.replace("{addressId}", encodeURIComponent("" + addressId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAddress(_response);
        });
    }

    protected processDeleteAddress(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateCurrentAddress(model: MysteryShopperAddressDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/profile/addresses/current";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCurrentAddress(_response);
        });
    }

    protected processUpdateCurrentAddress(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    registerDevice(device: RegisterDeviceDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/device";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(device);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterDevice(_response);
        });
    }

    protected processRegisterDevice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getAlertBanner( cancelToken?: CancelToken): Promise<GetAlertBannerViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/alert";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAlertBanner(_response);
        });
    }

    protected processGetAlertBanner(response: AxiosResponse): Promise<GetAlertBannerViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAlertBannerViewModel.fromJS(resultData200);
            return Promise.resolve<GetAlertBannerViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAlertBannerViewModel>(null as any);
    }

    getAdvertisementTracking( cancelToken?: CancelToken): Promise<GetAdvertisementTrackingListViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/advertisement-tracking";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdvertisementTracking(_response);
        });
    }

    protected processGetAdvertisementTracking(response: AxiosResponse): Promise<GetAdvertisementTrackingListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAdvertisementTrackingListViewModel.fromJS(resultData200);
            return Promise.resolve<GetAdvertisementTrackingListViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAdvertisementTrackingListViewModel>(null as any);
    }

    resetAdvertisementTracking( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/advertisement-tracking";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetAdvertisementTracking(_response);
        });
    }

    protected processResetAdvertisementTracking(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getAdvertisementTrackingByCode(code: string, cancelToken?: CancelToken): Promise<GetAdvertisementTrackingByCodeViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/advertisement-tracking/{code}";
        if (code === undefined || code === null)
            throw new globalThis.Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdvertisementTrackingByCode(_response);
        });
    }

    protected processGetAdvertisementTrackingByCode(response: AxiosResponse): Promise<GetAdvertisementTrackingByCodeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAdvertisementTrackingByCodeViewModel.fromJS(resultData200);
            return Promise.resolve<GetAdvertisementTrackingByCodeViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAdvertisementTrackingByCodeViewModel>(null as any);
    }

    updateAdvertisementTracking(code: string, data: UpdateAdvertisementTrackingByCodeDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/advertisement-tracking/{code}";
        if (code === undefined || code === null)
            throw new globalThis.Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAdvertisementTracking(_response);
        });
    }

    protected processUpdateAdvertisementTracking(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resetAdvertisementTrackingByCode(code: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/advertisement-tracking/{code}";
        if (code === undefined || code === null)
            throw new globalThis.Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetAdvertisementTrackingByCode(_response);
        });
    }

    protected processResetAdvertisementTrackingByCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getNotificationSettings( cancelToken?: CancelToken): Promise<GetNotificationSettingsViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/notification-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotificationSettings(_response);
        });
    }

    protected processGetNotificationSettings(response: AxiosResponse): Promise<GetNotificationSettingsViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetNotificationSettingsViewModel.fromJS(resultData200);
            return Promise.resolve<GetNotificationSettingsViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetNotificationSettingsViewModel>(null as any);
    }

    saveNotificationSettings(data: SaveNotificationSettingsRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/notification-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveNotificationSettings(_response);
        });
    }

    protected processSaveNotificationSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteMysteryShopper( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMysteryShopper(_response);
        });
    }

    protected processDeleteMysteryShopper(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    unsubscribeMysteryShopper(mysteryShopperEmail: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/unsubscribe?";
        if (mysteryShopperEmail === null)
            throw new globalThis.Error("The parameter 'mysteryShopperEmail' cannot be null.");
        else if (mysteryShopperEmail !== undefined)
            url_ += "mysteryShopperEmail=" + encodeURIComponent("" + mysteryShopperEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnsubscribeMysteryShopper(_response);
        });
    }

    protected processUnsubscribeMysteryShopper(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: String(response.headers["content-type"] ?? "") }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    verifyPhoneNumber(phoneNumber: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/verify/phonenumber?";
        if (phoneNumber === null)
            throw new globalThis.Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyPhoneNumber(_response);
        });
    }

    protected processVerifyPhoneNumber(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class QualityWarningsClient extends BaseApi {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create(this.commonConfig);

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://api.hulk.cool");

    }

    getQualityWarning( cancelToken?: CancelToken): Promise<QualityWarningSummaryResponse> {
        let url_ = this.baseUrl + "/api/ms/client/quality-warnings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQualityWarning(_response);
        });
    }

    protected processGetQualityWarning(response: AxiosResponse): Promise<QualityWarningSummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QualityWarningSummaryResponse.fromJS(resultData200);
            return Promise.resolve<QualityWarningSummaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QualityWarningSummaryResponse>(null as any);
    }

    recordQualityWarningDisplay(warningId: string, cancelToken?: CancelToken): Promise<QualityWarningSummaryResponse> {
        let url_ = this.baseUrl + "/api/ms/client/quality-warnings/{warningId}/display";
        if (warningId === undefined || warningId === null)
            throw new globalThis.Error("The parameter 'warningId' must be defined.");
        url_ = url_.replace("{warningId}", encodeURIComponent("" + warningId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecordQualityWarningDisplay(_response);
        });
    }

    protected processRecordQualityWarningDisplay(response: AxiosResponse): Promise<QualityWarningSummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QualityWarningSummaryResponse.fromJS(resultData200);
            return Promise.resolve<QualityWarningSummaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QualityWarningSummaryResponse>(null as any);
    }

    acknowledgeQualityWarning(warningId: string, cancelToken?: CancelToken): Promise<QualityWarningSummaryResponse> {
        let url_ = this.baseUrl + "/api/ms/client/quality-warnings/{warningId}/acknowledge";
        if (warningId === undefined || warningId === null)
            throw new globalThis.Error("The parameter 'warningId' must be defined.");
        url_ = url_.replace("{warningId}", encodeURIComponent("" + warningId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcknowledgeQualityWarning(_response);
        });
    }

    protected processAcknowledgeQualityWarning(response: AxiosResponse): Promise<QualityWarningSummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QualityWarningSummaryResponse.fromJS(resultData200);
            return Promise.resolve<QualityWarningSummaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QualityWarningSummaryResponse>(null as any);
    }
}

export class SimulateErrorsClient extends BaseApi {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create(this.commonConfig);

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://api.hulk.cool");

    }

    get401( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/ms/client/simulate-errors/401";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet401(_response);
        });
    }

    protected processGet401(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    get403( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/ms/client/simulate-errors/403";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet403(_response);
        });
    }

    protected processGet403(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    get404( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/ms/client/simulate-errors/404";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet404(_response);
        });
    }

    protected processGet404(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    get409( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/ms/client/simulate-errors/409";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet409(_response);
        });
    }

    protected processGet409(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class SurveyImagesClient extends BaseApi {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create(this.commonConfig);

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://api.hulk.cool");

    }

    upload(contentType: string | null | undefined, contentDisposition: string | null | undefined, headers: any[] | null | undefined, length: number | undefined, name: string | null | undefined, fileName: string | null | undefined, cancelToken?: CancelToken): Promise<SurveyImageUploadResponse> {
        let url_ = this.baseUrl + "/api/ms/client/survey-images";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            headers.forEach(item_ => content_.append("Headers", item_.toString()));
        if (length === null || length === undefined)
            throw new globalThis.Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: AxiosResponse): Promise<SurveyImageUploadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SurveyImageUploadResponse.fromJS(resultData200);
            return Promise.resolve<SurveyImageUploadResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyImageUploadResponse>(null as any);
    }

    get(imageId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ms/client/survey-images/{imageId}";
        if (imageId === undefined || imageId === null)
            throw new globalThis.Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: String(response.headers["content-type"] ?? "") }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(imageId: string, missionAssignationId: string | null | undefined, missionAnswerId: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ms/client/survey-images/{imageId}?";
        if (imageId === undefined || imageId === null)
            throw new globalThis.Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        if (missionAssignationId !== undefined && missionAssignationId !== null)
            url_ += "missionAssignationId=" + encodeURIComponent("" + missionAssignationId) + "&";
        if (missionAnswerId !== undefined && missionAnswerId !== null)
            url_ += "missionAnswerId=" + encodeURIComponent("" + missionAnswerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: String(response.headers["content-type"] ?? "") }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TagsClient extends BaseApi {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create(this.commonConfig);

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://api.hulk.cool");

    }

    getTags( cancelToken?: CancelToken): Promise<GetTagsViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Tags";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTags(_response);
        });
    }

    protected processGetTags(response: AxiosResponse): Promise<GetTagsViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTagsViewModel.fromJS(resultData200);
            return Promise.resolve<GetTagsViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTagsViewModel>(null as any);
    }
}

export class TransactionsClient extends BaseApi {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create(this.commonConfig);

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://api.hulk.cool");

    }

    getTransactions(continuationToken: string | null | undefined, pageSize: number | undefined, filters: GetTransactionListFilter | undefined, cancelToken?: CancelToken): Promise<GetTransactionListViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Transactions?";
        if (continuationToken !== undefined && continuationToken !== null)
            url_ += "ContinuationToken=" + encodeURIComponent("" + continuationToken) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTransactions(_response);
        });
    }

    protected processGetTransactions(response: AxiosResponse): Promise<GetTransactionListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTransactionListViewModel.fromJS(resultData200);
            return Promise.resolve<GetTransactionListViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTransactionListViewModel>(null as any);
    }

    canProceedToCashOut( cancelToken?: CancelToken): Promise<CanProceedToCashOutViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Transactions/cashout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCanProceedToCashOut(_response);
        });
    }

    protected processCanProceedToCashOut(response: AxiosResponse): Promise<CanProceedToCashOutViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CanProceedToCashOutViewModel.fromJS(resultData200);
            return Promise.resolve<CanProceedToCashOutViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CanProceedToCashOutViewModel>(null as any);
    }

    proceedToCashOut( cancelToken?: CancelToken): Promise<ProceedToCashOutViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Transactions/cashout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProceedToCashOut(_response);
        });
    }

    protected processProceedToCashOut(response: AxiosResponse): Promise<ProceedToCashOutViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProceedToCashOutViewModel.fromJS(resultData200);
            return Promise.resolve<ProceedToCashOutViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProceedToCashOutViewModel>(null as any);
    }

    cancelCashOut(cashoutTransactionId: string, cancelToken?: CancelToken): Promise<CancelCashOutViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Transactions/cashout/{cashoutTransactionId}/cancel";
        if (cashoutTransactionId === undefined || cashoutTransactionId === null)
            throw new globalThis.Error("The parameter 'cashoutTransactionId' must be defined.");
        url_ = url_.replace("{cashoutTransactionId}", encodeURIComponent("" + cashoutTransactionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelCashOut(_response);
        });
    }

    protected processCancelCashOut(response: AxiosResponse): Promise<CancelCashOutViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CancelCashOutViewModel.fromJS(resultData200);
            return Promise.resolve<CancelCashOutViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CancelCashOutViewModel>(null as any);
    }
}

export class GetAppReviewPromptEligibilityViewModel {
    eligible?: boolean;
    promptId?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.eligible = _data["eligible"];
            this.promptId = _data["promptId"];
        }
    }

    static fromJS(data: any): GetAppReviewPromptEligibilityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppReviewPromptEligibilityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eligible"] = this.eligible;
        data["promptId"] = this.promptId;
        return data;
    }
}

export class AppReviewPromptActionViewModel {
    success?: boolean;
    error?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): AppReviewPromptActionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppReviewPromptActionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export class SubmitAppReviewPromptFeedbackRequest {
    rating?: number;
    selectedReasons?: AppReviewPromptFeedbackReason[] | undefined;
    comment?: string | undefined;
    platform?: AppReviewPromptPlatform | undefined;

    init(_data?: any) {
        if (_data) {
            this.rating = _data["rating"];
            if (Array.isArray(_data["selectedReasons"])) {
                this.selectedReasons = [] as any;
                for (let item of _data["selectedReasons"])
                    this.selectedReasons!.push(item);
            }
            this.comment = _data["comment"];
            this.platform = _data["platform"];
        }
    }

    static fromJS(data: any): SubmitAppReviewPromptFeedbackRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitAppReviewPromptFeedbackRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rating"] = this.rating;
        if (Array.isArray(this.selectedReasons)) {
            data["selectedReasons"] = [];
            for (let item of this.selectedReasons)
                data["selectedReasons"].push(item);
        }
        data["comment"] = this.comment;
        data["platform"] = this.platform;
        return data;
    }
}

export enum AppReviewPromptFeedbackReason {
    MissionInstructionsUnclear = "MissionInstructionsUnclear",
    PaymentIssues = "PaymentIssues",
    AppProblemOrBug = "AppProblemOrBug",
    NotEnoughMissionsNearby = "NotEnoughMissionsNearby",
    Other = "Other",
}

export enum AppReviewPromptPlatform {
    Web = "Web",
    Ios = "Ios",
    Android = "Android",
}

export class RecordAppReviewPromptEventRequest {
    eventType?: AppReviewPromptEventType | undefined;
    rating?: number | undefined;
    comment?: string | undefined;
    selectedReasons?: AppReviewPromptFeedbackReason[] | undefined;
    platform?: AppReviewPromptPlatform | undefined;
    destination?: AppReviewPromptPublicReviewDestination | undefined;

    init(_data?: any) {
        if (_data) {
            this.eventType = _data["eventType"];
            this.rating = _data["rating"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["selectedReasons"])) {
                this.selectedReasons = [] as any;
                for (let item of _data["selectedReasons"])
                    this.selectedReasons!.push(item);
            }
            this.platform = _data["platform"];
            this.destination = _data["destination"];
        }
    }

    static fromJS(data: any): RecordAppReviewPromptEventRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RecordAppReviewPromptEventRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventType"] = this.eventType;
        data["rating"] = this.rating;
        data["comment"] = this.comment;
        if (Array.isArray(this.selectedReasons)) {
            data["selectedReasons"] = [];
            for (let item of this.selectedReasons)
                data["selectedReasons"].push(item);
        }
        data["platform"] = this.platform;
        data["destination"] = this.destination;
        return data;
    }
}

export enum AppReviewPromptEventType {
    Dismissed = "Dismissed",
    RatingSubmitted = "RatingSubmitted",
    FeedbackSent = "FeedbackSent",
    ContactSupportClicked = "ContactSupportClicked",
    PublicReviewClicked = "PublicReviewClicked",
}

export enum AppReviewPromptPublicReviewDestination {
    AppStore = "AppStore",
    GooglePlay = "GooglePlay",
}

export class MysteryShopperExistsViewModel {
    exists?: boolean;

    init(_data?: any) {
        if (_data) {
            this.exists = _data["exists"];
        }
    }

    static fromJS(data: any): MysteryShopperExistsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MysteryShopperExistsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exists"] = this.exists;
        return data;
    }
}

export class RegistrationDto {
    deviceTheme?: DeviceTheme;
    signUpSource?: string | undefined;
    language?: string | undefined;
    firebaseId?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.deviceTheme = _data["deviceTheme"];
            this.signUpSource = _data["signUpSource"];
            this.language = _data["language"];
            this.firebaseId = _data["firebaseId"];
        }
    }

    static fromJS(data: any): RegistrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceTheme"] = this.deviceTheme;
        data["signUpSource"] = this.signUpSource;
        data["language"] = this.language;
        data["firebaseId"] = this.firebaseId;
        return data;
    }
}

export enum DeviceTheme {
    Light = 0,
    Dark = 1,
    System = 2,
}

export class ExternalLoginRequest {
    email?: string;
    password?: string;

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ExternalLoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export class ExternalExistsRequest {
    email?: string;

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ExternalExistsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalExistsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export class CampaignRedirectResponse {
    redirectUrl?: string;

    init(_data?: any) {
        if (_data) {
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): CampaignRedirectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignRedirectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export class CampaignRegistrationRequest {
    submissionId?: string;
    campaignId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string;
    phone?: string | undefined;
    postalCode?: string | undefined;
    language?: string;
    consentAccepted?: boolean | undefined;
    consentVersion?: string | undefined;
    consentAtUtc?: Date | undefined;
    codeChallenge?: string;
    state?: string;

    init(_data?: any) {
        if (_data) {
            this.submissionId = _data["submissionId"];
            this.campaignId = _data["campaignId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.postalCode = _data["postalCode"];
            this.language = _data["language"];
            this.consentAccepted = _data["consentAccepted"];
            this.consentVersion = _data["consentVersion"];
            this.consentAtUtc = _data["consentAtUtc"] ? new Date(_data["consentAtUtc"].toString()) : undefined as any;
            this.codeChallenge = _data["codeChallenge"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): CampaignRegistrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignRegistrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionId"] = this.submissionId;
        data["campaignId"] = this.campaignId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["postalCode"] = this.postalCode;
        data["language"] = this.language;
        data["consentAccepted"] = this.consentAccepted;
        data["consentVersion"] = this.consentVersion;
        data["consentAtUtc"] = this.consentAtUtc ? this.consentAtUtc.toISOString() : undefined as any;
        data["codeChallenge"] = this.codeChallenge;
        data["state"] = this.state;
        return data;
    }
}

export class CampaignExchangeResponse {
    loginRequired?: boolean;
    customToken?: string | undefined;
    postalCode?: string | undefined;
    language?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;

    init(_data?: any) {
        if (_data) {
            this.loginRequired = _data["loginRequired"];
            this.customToken = _data["customToken"];
            this.postalCode = _data["postalCode"];
            this.language = _data["language"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): CampaignExchangeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignExchangeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loginRequired"] = this.loginRequired;
        data["customToken"] = this.customToken;
        data["postalCode"] = this.postalCode;
        data["language"] = this.language;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export class CampaignExchangeRequest {
    code?: string;
    codeVerifier?: string;
    state?: string;

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.codeVerifier = _data["codeVerifier"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): CampaignExchangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignExchangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["codeVerifier"] = this.codeVerifier;
        data["state"] = this.state;
        return data;
    }
}

export class CampaignSetupEmailRequest {
    email?: string;

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CampaignSetupEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignSetupEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export class CompleteCampaignSetupResponse {
    email?: string;

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CompleteCampaignSetupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteCampaignSetupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export class CompleteCampaignSetupRequest {
    token?: string;
    password?: string;

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CompleteCampaignSetupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteCampaignSetupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["password"] = this.password;
        return data;
    }
}

export class CampaignSecurityResponse {
    isCampaignAccount?: boolean;
    setupRequired?: boolean;
    accessAllowed?: boolean;
    initialExpiresAtUtc?: Date | undefined;

    init(_data?: any) {
        if (_data) {
            this.isCampaignAccount = _data["isCampaignAccount"];
            this.setupRequired = _data["setupRequired"];
            this.accessAllowed = _data["accessAllowed"];
            this.initialExpiresAtUtc = _data["initialExpiresAtUtc"] ? new Date(_data["initialExpiresAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CampaignSecurityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignSecurityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCampaignAccount"] = this.isCampaignAccount;
        data["setupRequired"] = this.setupRequired;
        data["accessAllowed"] = this.accessAllowed;
        data["initialExpiresAtUtc"] = this.initialExpiresAtUtc ? this.initialExpiresAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export class GetClientGlobalSettingsResponse {
    referAFriendEnabled?: boolean;
    remoteMissionsEnabled?: boolean;

    init(_data?: any) {
        if (_data) {
            this.referAFriendEnabled = _data["referAFriendEnabled"];
            this.remoteMissionsEnabled = _data["remoteMissionsEnabled"];
        }
    }

    static fromJS(data: any): GetClientGlobalSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientGlobalSettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referAFriendEnabled"] = this.referAFriendEnabled;
        data["remoteMissionsEnabled"] = this.remoteMissionsEnabled;
        return data;
    }
}

export class GetSurveyFromTempViewModel {
    formJson?: GetSurveyFromTempQueryDto;

    init(_data?: any) {
        if (_data) {
            this.formJson = _data["formJson"] ? GetSurveyFromTempQueryDto.fromJS(_data["formJson"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetSurveyFromTempViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyFromTempViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formJson"] = this.formJson ? this.formJson.toJSON() : undefined as any;
        return data;
    }
}

export class GetSurveyFromTempQueryDto {
    formJson?: string;

    init(_data?: any) {
        if (_data) {
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): GetSurveyFromTempQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyFromTempQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formJson"] = this.formJson;
        return data;
    }
}

export class GetMissionDetailsViewModel {
    missionDetails?: GetMissionDetailsDto[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["missionDetails"])) {
                this.missionDetails = [] as any;
                for (let item of _data["missionDetails"])
                    this.missionDetails!.push(GetMissionDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMissionDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.missionDetails)) {
            data["missionDetails"] = [];
            for (let item of this.missionDetails)
                data["missionDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class GetMissionDetailsDto {
    scenarioUpdateNotice?: ScenarioUpdateNoticeDto | undefined;
    periodMissionConfigurationId?: string;
    promotionDisplay?: MissionPromotionDisplayDto | undefined;
    periodStartDate?: Date | undefined;
    periodEndDate?: Date | undefined;
    name?: string;
    missionConfigurationName?: string;
    time?: string;
    phone?: string | undefined;
    hasLogo?: boolean;
    logoUrl?: string | undefined;
    address?: string;
    distance?: number | undefined;
    tags?: string;
    reimbursementValue?: string | undefined;
    reimbursementMaxAmount?: number | undefined;
    reimbursementMaxPoints?: number | undefined;
    salaryAmount?: number | undefined;
    salaryPoints?: number | undefined;
    requiredPurchase?: boolean;
    isTaken?: boolean;
    takenMissionAssignationId?: string | undefined;
    requiredPurchaseText?: string | undefined;
    requiredPurchaseExclusionText?: string | undefined;
    supportedCultureCodes?: string[] | undefined;
    missionType?: MissionType;
    isFlashMission?: boolean;
    acceptMissionStatus?: AcceptMissionStatus;
    isAvailableForDiscovery?: boolean;
    discoveryAvailabilityStatus?: MissionDiscoveryAvailabilityStatus;
    missionAssignationId?: string | undefined;
    rotationInfo?: AcceptMissionRotationInfoDto | undefined;
    missingProfileMembers?: GetMysteryShopperProfileMemberDto[] | undefined;
    storeLocatorLink?: string | undefined;
    isCompetitorCircuit?: boolean;
    competitorLocations?: CompetitorCircuitPreviewLocationDto[];
    branchAirportInfo?: MissionBranchAirportInfoDto | undefined;
    geocoordinate?: GeoLocation | undefined;
    referenceLocation?: GeoLocation | undefined;
    details?: MissionDetailsDto[];

    init(_data?: any) {
        if (_data) {
            this.scenarioUpdateNotice = _data["scenarioUpdateNotice"] ? ScenarioUpdateNoticeDto.fromJS(_data["scenarioUpdateNotice"]) : undefined as any;
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            this.promotionDisplay = _data["promotionDisplay"] ? MissionPromotionDisplayDto.fromJS(_data["promotionDisplay"]) : undefined as any;
            this.periodStartDate = _data["periodStartDate"] ? new Date(_data["periodStartDate"].toString()) : undefined as any;
            this.periodEndDate = _data["periodEndDate"] ? new Date(_data["periodEndDate"].toString()) : undefined as any;
            this.name = _data["name"];
            this.missionConfigurationName = _data["missionConfigurationName"];
            this.time = _data["time"];
            this.phone = _data["phone"];
            this.hasLogo = _data["hasLogo"];
            this.logoUrl = _data["logoUrl"];
            this.address = _data["address"];
            this.distance = _data["distance"];
            this.tags = _data["tags"];
            this.reimbursementValue = _data["reimbursementValue"];
            this.reimbursementMaxAmount = _data["reimbursementMaxAmount"];
            this.reimbursementMaxPoints = _data["reimbursementMaxPoints"];
            this.salaryAmount = _data["salaryAmount"];
            this.salaryPoints = _data["salaryPoints"];
            this.requiredPurchase = _data["requiredPurchase"];
            this.isTaken = _data["isTaken"];
            this.takenMissionAssignationId = _data["takenMissionAssignationId"];
            this.requiredPurchaseText = _data["requiredPurchaseText"];
            this.requiredPurchaseExclusionText = _data["requiredPurchaseExclusionText"];
            if (Array.isArray(_data["supportedCultureCodes"])) {
                this.supportedCultureCodes = [] as any;
                for (let item of _data["supportedCultureCodes"])
                    this.supportedCultureCodes!.push(item);
            }
            this.missionType = _data["missionType"];
            this.isFlashMission = _data["isFlashMission"];
            this.acceptMissionStatus = _data["acceptMissionStatus"];
            this.isAvailableForDiscovery = _data["isAvailableForDiscovery"];
            this.discoveryAvailabilityStatus = _data["discoveryAvailabilityStatus"];
            this.missionAssignationId = _data["missionAssignationId"];
            this.rotationInfo = _data["rotationInfo"] ? AcceptMissionRotationInfoDto.fromJS(_data["rotationInfo"]) : undefined as any;
            if (Array.isArray(_data["missingProfileMembers"])) {
                this.missingProfileMembers = [] as any;
                for (let item of _data["missingProfileMembers"])
                    this.missingProfileMembers!.push(GetMysteryShopperProfileMemberDto.fromJS(item));
            }
            this.storeLocatorLink = _data["storeLocatorLink"];
            this.isCompetitorCircuit = _data["isCompetitorCircuit"];
            if (Array.isArray(_data["competitorLocations"])) {
                this.competitorLocations = [] as any;
                for (let item of _data["competitorLocations"])
                    this.competitorLocations!.push(CompetitorCircuitPreviewLocationDto.fromJS(item));
            }
            this.branchAirportInfo = _data["branchAirportInfo"] ? MissionBranchAirportInfoDto.fromJS(_data["branchAirportInfo"]) : undefined as any;
            this.geocoordinate = _data["geocoordinate"] ? GeoLocation.fromJS(_data["geocoordinate"]) : undefined as any;
            this.referenceLocation = _data["referenceLocation"] ? GeoLocation.fromJS(_data["referenceLocation"]) : undefined as any;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(MissionDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMissionDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioUpdateNotice"] = this.scenarioUpdateNotice ? this.scenarioUpdateNotice.toJSON() : undefined as any;
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        data["promotionDisplay"] = this.promotionDisplay ? this.promotionDisplay.toJSON() : undefined as any;
        data["periodStartDate"] = this.periodStartDate ? this.periodStartDate.toISOString() : undefined as any;
        data["periodEndDate"] = this.periodEndDate ? this.periodEndDate.toISOString() : undefined as any;
        data["name"] = this.name;
        data["missionConfigurationName"] = this.missionConfigurationName;
        data["time"] = this.time;
        data["phone"] = this.phone;
        data["hasLogo"] = this.hasLogo;
        data["logoUrl"] = this.logoUrl;
        data["address"] = this.address;
        data["distance"] = this.distance;
        data["tags"] = this.tags;
        data["reimbursementValue"] = this.reimbursementValue;
        data["reimbursementMaxAmount"] = this.reimbursementMaxAmount;
        data["reimbursementMaxPoints"] = this.reimbursementMaxPoints;
        data["salaryAmount"] = this.salaryAmount;
        data["salaryPoints"] = this.salaryPoints;
        data["requiredPurchase"] = this.requiredPurchase;
        data["isTaken"] = this.isTaken;
        data["takenMissionAssignationId"] = this.takenMissionAssignationId;
        data["requiredPurchaseText"] = this.requiredPurchaseText;
        data["requiredPurchaseExclusionText"] = this.requiredPurchaseExclusionText;
        if (Array.isArray(this.supportedCultureCodes)) {
            data["supportedCultureCodes"] = [];
            for (let item of this.supportedCultureCodes)
                data["supportedCultureCodes"].push(item);
        }
        data["missionType"] = this.missionType;
        data["isFlashMission"] = this.isFlashMission;
        data["acceptMissionStatus"] = this.acceptMissionStatus;
        data["isAvailableForDiscovery"] = this.isAvailableForDiscovery;
        data["discoveryAvailabilityStatus"] = this.discoveryAvailabilityStatus;
        data["missionAssignationId"] = this.missionAssignationId;
        data["rotationInfo"] = this.rotationInfo ? this.rotationInfo.toJSON() : undefined as any;
        if (Array.isArray(this.missingProfileMembers)) {
            data["missingProfileMembers"] = [];
            for (let item of this.missingProfileMembers)
                data["missingProfileMembers"].push(item ? item.toJSON() : undefined as any);
        }
        data["storeLocatorLink"] = this.storeLocatorLink;
        data["isCompetitorCircuit"] = this.isCompetitorCircuit;
        if (Array.isArray(this.competitorLocations)) {
            data["competitorLocations"] = [];
            for (let item of this.competitorLocations)
                data["competitorLocations"].push(item ? item.toJSON() : undefined as any);
        }
        data["branchAirportInfo"] = this.branchAirportInfo ? this.branchAirportInfo.toJSON() : undefined as any;
        data["geocoordinate"] = this.geocoordinate ? this.geocoordinate.toJSON() : undefined as any;
        data["referenceLocation"] = this.referenceLocation ? this.referenceLocation.toJSON() : undefined as any;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class ScenarioUpdateNoticeDto {
    isActive?: boolean;
    expiresAtUtc?: Date | undefined;
    refreshAfterSeconds?: number | undefined;

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.expiresAtUtc = _data["expiresAtUtc"] ? new Date(_data["expiresAtUtc"].toString()) : undefined as any;
            this.refreshAfterSeconds = _data["refreshAfterSeconds"];
        }
    }

    static fromJS(data: any): ScenarioUpdateNoticeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioUpdateNoticeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["expiresAtUtc"] = this.expiresAtUtc ? this.expiresAtUtc.toISOString() : undefined as any;
        data["refreshAfterSeconds"] = this.refreshAfterSeconds;
        return data;
    }
}

export class MissionPromotionDisplayDto {
    promotions?: MissionPromotionDto[];
    refreshAfterSeconds?: number | undefined;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["promotions"])) {
                this.promotions = [] as any;
                for (let item of _data["promotions"])
                    this.promotions!.push(MissionPromotionDto.fromJS(item));
            }
            this.refreshAfterSeconds = _data["refreshAfterSeconds"];
        }
    }

    static fromJS(data: any): MissionPromotionDisplayDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissionPromotionDisplayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.promotions)) {
            data["promotions"] = [];
            for (let item of this.promotions)
                data["promotions"].push(item ? item.toJSON() : undefined as any);
        }
        data["refreshAfterSeconds"] = this.refreshAfterSeconds;
        return data;
    }
}

export class MissionPromotionDto {
    periodMissionConfigurationId?: string;
    label?: string;
    details?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    timeZoneId?: string;

    init(_data?: any) {
        if (_data) {
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            this.label = _data["label"];
            this.details = _data["details"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.timeZoneId = _data["timeZoneId"];
        }
    }

    static fromJS(data: any): MissionPromotionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissionPromotionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        data["label"] = this.label;
        data["details"] = this.details;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["timeZoneId"] = this.timeZoneId;
        return data;
    }
}

export enum MissionType {
    Regular = 1,
    Airport = 2,
}

export enum AcceptMissionStatus {
    UserNotAuthenticated = 0,
    MissionUnavailable = 1,
    MissionAlreadyInProgress = 2,
    IncompleteProfileRequirements = 3,
    UserIneligibleForMission = 4,
    MissionLimitReached = 5,
    MissionLimitRotationReach = 6,
    MissionEligible = 7,
    Retry = 8,
    ScenarioReviewRequired = 9,
}

export enum MissionDiscoveryAvailabilityStatus {
    Available = 0,
    RequiresAdultIdVerification = 1,
    Unavailable = 2,
}

export class AcceptMissionRotationInfoDto {
    isRotationValid?: boolean;
    rotationType?: RotationType;
    isBlockedByLinkedMysteryShopper?: boolean;
    nextAvailableDate?: Date | undefined;

    init(_data?: any) {
        if (_data) {
            this.isRotationValid = _data["isRotationValid"];
            this.rotationType = _data["rotationType"];
            this.isBlockedByLinkedMysteryShopper = _data["isBlockedByLinkedMysteryShopper"];
            this.nextAvailableDate = _data["nextAvailableDate"] ? new Date(_data["nextAvailableDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AcceptMissionRotationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptMissionRotationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isRotationValid"] = this.isRotationValid;
        data["rotationType"] = this.rotationType;
        data["isBlockedByLinkedMysteryShopper"] = this.isBlockedByLinkedMysteryShopper;
        data["nextAvailableDate"] = this.nextAvailableDate ? this.nextAvailableDate.toISOString() : undefined as any;
        return data;
    }
}

export enum RotationType {
    Unlimited = 0,
    PeriodMissionConfiguration = 1,
    Period = 2,
    MissionConfiguration = 3,
    Project = 4,
    Subscription = 5,
    Days = 6,
    PeriodMissionConfigurationGroup = 7,
}

export class GetMysteryShopperProfileMemberDto {
    key?: string;
    label?: string;
    question?: string;
    valueType?: MysteryShopperProfileMemberType;
    minValue?: string | undefined;
    maxValue?: string | undefined;
    choices?: GetMysteryShopperProfileMemberChoiceDto[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.question = _data["question"];
            this.valueType = _data["valueType"];
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(GetMysteryShopperProfileMemberChoiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMysteryShopperProfileMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperProfileMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["question"] = this.question;
        data["valueType"] = this.valueType;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export enum MysteryShopperProfileMemberType {
    SingleChoice = 0,
    MultipleChoices = 1,
    Int32 = 2,
    String = 3,
    Date = 4,
}

export class GetMysteryShopperProfileMemberChoiceDto {
    key?: number;
    label?: string;

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): GetMysteryShopperProfileMemberChoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperProfileMemberChoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        return data;
    }
}

export class CompetitorCircuitPreviewLocationDto {
    competitorBranchId?: string;
    name?: string;
    address?: string;
    geocoordinate?: GeoLocation | undefined;

    init(_data?: any) {
        if (_data) {
            this.competitorBranchId = _data["competitorBranchId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.geocoordinate = _data["geocoordinate"] ? GeoLocation.fromJS(_data["geocoordinate"]) : undefined as any;
        }
    }

    static fromJS(data: any): CompetitorCircuitPreviewLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitorCircuitPreviewLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitorBranchId"] = this.competitorBranchId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["geocoordinate"] = this.geocoordinate ? this.geocoordinate.toJSON() : undefined as any;
        return data;
    }
}

export class GeoLocation {
    x?: number;
    y?: number;

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
        }
    }

    static fromJS(data: any): GeoLocation {
        data = typeof data === 'object' ? data : {};
        let result = new GeoLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        return data;
    }
}

export class MissionBranchAirportInfoDto {
    airportId?: string;
    airportName?: string;
    zoneId?: string;
    zoneName?: string;
    isRestrictedArea?: boolean;
    gateId?: string | undefined;
    gateName?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.airportId = _data["airportId"];
            this.airportName = _data["airportName"];
            this.zoneId = _data["zoneId"];
            this.zoneName = _data["zoneName"];
            this.isRestrictedArea = _data["isRestrictedArea"];
            this.gateId = _data["gateId"];
            this.gateName = _data["gateName"];
        }
    }

    static fromJS(data: any): MissionBranchAirportInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissionBranchAirportInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airportId"] = this.airportId;
        data["airportName"] = this.airportName;
        data["zoneId"] = this.zoneId;
        data["zoneName"] = this.zoneName;
        data["isRestrictedArea"] = this.isRestrictedArea;
        data["gateId"] = this.gateId;
        data["gateName"] = this.gateName;
        return data;
    }
}

export class MissionDetailsDto {
    type?: MissionConfigurationDetailType;
    text?: string;

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): MissionDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissionDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["text"] = this.text;
        return data;
    }
}

export enum MissionConfigurationDetailType {
    Objective = 0,
    Eligibility = 1,
    TermsAndConditions = 2,
    ToNote = 3,
    Scenario = 4,
    NiceToKnow = 5,
}

export class RemoteMissionSummaryDto {
    promotionDisplay?: MissionPromotionDisplayDto | undefined;
    periodMissionConfigurationId?: string;
    missionConfigurationId?: string;
    name?: string;
    brandName?: string;
    upcomingPeriod?: boolean;
    upcomingPeriodStartDate?: Date | undefined;
    closingDate?: Date | undefined;
    durationDays?: number | undefined;
    salaryAmount?: number | undefined;
    salaryPoints?: number | undefined;
    activity?: RemoteMissionActivity;
    requiresPhoneCall?: boolean;
    requiresEmail?: boolean;
    locationType?: LocationSettingsType;
    allocation?: RemoteMissionAllocation;
    configured?: number;
    released?: number;
    taken?: number;
    remaining?: number;
    hasLogo?: boolean;
    logoUrl?: string | undefined;
    tags?: RemoteMissionTagDto[];

    init(_data?: any) {
        if (_data) {
            this.promotionDisplay = _data["promotionDisplay"] ? MissionPromotionDisplayDto.fromJS(_data["promotionDisplay"]) : undefined as any;
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            this.missionConfigurationId = _data["missionConfigurationId"];
            this.name = _data["name"];
            this.brandName = _data["brandName"];
            this.upcomingPeriod = _data["upcomingPeriod"];
            this.upcomingPeriodStartDate = _data["upcomingPeriodStartDate"] ? new Date(_data["upcomingPeriodStartDate"].toString()) : undefined as any;
            this.closingDate = _data["closingDate"] ? new Date(_data["closingDate"].toString()) : undefined as any;
            this.durationDays = _data["durationDays"];
            this.salaryAmount = _data["salaryAmount"];
            this.salaryPoints = _data["salaryPoints"];
            this.activity = _data["activity"];
            this.requiresPhoneCall = _data["requiresPhoneCall"];
            this.requiresEmail = _data["requiresEmail"];
            this.locationType = _data["locationType"];
            this.allocation = _data["allocation"];
            this.configured = _data["configured"];
            this.released = _data["released"];
            this.taken = _data["taken"];
            this.remaining = _data["remaining"];
            this.hasLogo = _data["hasLogo"];
            this.logoUrl = _data["logoUrl"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(RemoteMissionTagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RemoteMissionSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteMissionSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promotionDisplay"] = this.promotionDisplay ? this.promotionDisplay.toJSON() : undefined as any;
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        data["missionConfigurationId"] = this.missionConfigurationId;
        data["name"] = this.name;
        data["brandName"] = this.brandName;
        data["upcomingPeriod"] = this.upcomingPeriod;
        data["upcomingPeriodStartDate"] = this.upcomingPeriodStartDate ? this.upcomingPeriodStartDate.toISOString() : undefined as any;
        data["closingDate"] = this.closingDate ? this.closingDate.toISOString() : undefined as any;
        data["durationDays"] = this.durationDays;
        data["salaryAmount"] = this.salaryAmount;
        data["salaryPoints"] = this.salaryPoints;
        data["activity"] = this.activity;
        data["requiresPhoneCall"] = this.requiresPhoneCall;
        data["requiresEmail"] = this.requiresEmail;
        data["locationType"] = this.locationType;
        data["allocation"] = this.allocation;
        data["configured"] = this.configured;
        data["released"] = this.released;
        data["taken"] = this.taken;
        data["remaining"] = this.remaining;
        data["hasLogo"] = this.hasLogo;
        data["logoUrl"] = this.logoUrl;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export enum RemoteMissionActivity {
    SurveyOnly = 1,
    ActivityAndSurvey = 2,
}

export enum LocationSettingsType {
    OnSite = 0,
    AtHome = 1,
}

export enum RemoteMissionAllocation {
    SharedPool = 1,
    PerBranch = 2,
}

export class RemoteMissionTagDto {
    id?: string;
    name?: string;
    svgIcon?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.svgIcon = _data["svgIcon"];
        }
    }

    static fromJS(data: any): RemoteMissionTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteMissionTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["svgIcon"] = this.svgIcon;
        return data;
    }
}

export class GetRemoteMissionDetailsResponse {
    scenarioUpdateNotice?: ScenarioUpdateNoticeDto | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    website?: string | undefined;
    requiredPurchase?: boolean;
    requiredPurchaseText?: string | undefined;
    requiredPurchaseExclusionText?: string | undefined;
    reimbursementValue?: string | undefined;
    reimbursementMaxAmount?: number | undefined;
    totalPaymentMaxAmount?: number | undefined;
    summary?: RemoteMissionSummaryDto;
    details?: RemoteMissionDetailSectionDto[];
    branches?: RemoteMissionBranchChoiceDto[];

    init(_data?: any) {
        if (_data) {
            this.scenarioUpdateNotice = _data["scenarioUpdateNotice"] ? ScenarioUpdateNoticeDto.fromJS(_data["scenarioUpdateNotice"]) : undefined as any;
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.requiredPurchase = _data["requiredPurchase"];
            this.requiredPurchaseText = _data["requiredPurchaseText"];
            this.requiredPurchaseExclusionText = _data["requiredPurchaseExclusionText"];
            this.reimbursementValue = _data["reimbursementValue"];
            this.reimbursementMaxAmount = _data["reimbursementMaxAmount"];
            this.totalPaymentMaxAmount = _data["totalPaymentMaxAmount"];
            this.summary = _data["summary"] ? RemoteMissionSummaryDto.fromJS(_data["summary"]) : undefined as any;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(RemoteMissionDetailSectionDto.fromJS(item));
            }
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(RemoteMissionBranchChoiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRemoteMissionDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRemoteMissionDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioUpdateNotice"] = this.scenarioUpdateNotice ? this.scenarioUpdateNotice.toJSON() : undefined as any;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["website"] = this.website;
        data["requiredPurchase"] = this.requiredPurchase;
        data["requiredPurchaseText"] = this.requiredPurchaseText;
        data["requiredPurchaseExclusionText"] = this.requiredPurchaseExclusionText;
        data["reimbursementValue"] = this.reimbursementValue;
        data["reimbursementMaxAmount"] = this.reimbursementMaxAmount;
        data["totalPaymentMaxAmount"] = this.totalPaymentMaxAmount;
        data["summary"] = this.summary ? this.summary.toJSON() : undefined as any;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class RemoteMissionDetailSectionDto {
    type?: MissionConfigurationDetailType;
    text?: string;

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): RemoteMissionDetailSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteMissionDetailSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["text"] = this.text;
        return data;
    }
}

export class RemoteMissionBranchChoiceDto {
    branchId?: string;
    name?: string;
    address?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    website?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    configured?: number;
    released?: number;
    taken?: number;
    remaining?: number;
    availabilityBlocked?: boolean;
    availabilityBlockReason?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.configured = _data["configured"];
            this.released = _data["released"];
            this.taken = _data["taken"];
            this.remaining = _data["remaining"];
            this.availabilityBlocked = _data["availabilityBlocked"];
            this.availabilityBlockReason = _data["availabilityBlockReason"];
        }
    }

    static fromJS(data: any): RemoteMissionBranchChoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteMissionBranchChoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["city"] = this.city;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["website"] = this.website;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["configured"] = this.configured;
        data["released"] = this.released;
        data["taken"] = this.taken;
        data["remaining"] = this.remaining;
        data["availabilityBlocked"] = this.availabilityBlocked;
        data["availabilityBlockReason"] = this.availabilityBlockReason;
        return data;
    }
}

export class GetRemoteMissionEligibilityResponse {
    periodMissionConfigurationId?: string;
    branchId?: string | undefined;
    canAccept?: boolean;
    status?: AcceptMissionStatus;
    hardLimitReached?: boolean;
    verifyUserPhoneNumber?: boolean;
    ageRestrictionType?: AgeRestrictionType | undefined;
    requiresAdultIdVerification?: boolean;
    requiresRelatedMinorSelection?: boolean;
    eligibleRelatedMinors?: EligibleRelatedMinorDto[];
    missingProfileMembers?: GetMysteryShopperProfileMemberDto[] | undefined;
    rotationInfo?: AcceptMissionRotationInfoDto | undefined;

    init(_data?: any) {
        if (_data) {
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            this.branchId = _data["branchId"];
            this.canAccept = _data["canAccept"];
            this.status = _data["status"];
            this.hardLimitReached = _data["hardLimitReached"];
            this.verifyUserPhoneNumber = _data["verifyUserPhoneNumber"];
            this.ageRestrictionType = _data["ageRestrictionType"];
            this.requiresAdultIdVerification = _data["requiresAdultIdVerification"];
            this.requiresRelatedMinorSelection = _data["requiresRelatedMinorSelection"];
            if (Array.isArray(_data["eligibleRelatedMinors"])) {
                this.eligibleRelatedMinors = [] as any;
                for (let item of _data["eligibleRelatedMinors"])
                    this.eligibleRelatedMinors!.push(EligibleRelatedMinorDto.fromJS(item));
            }
            if (Array.isArray(_data["missingProfileMembers"])) {
                this.missingProfileMembers = [] as any;
                for (let item of _data["missingProfileMembers"])
                    this.missingProfileMembers!.push(GetMysteryShopperProfileMemberDto.fromJS(item));
            }
            this.rotationInfo = _data["rotationInfo"] ? AcceptMissionRotationInfoDto.fromJS(_data["rotationInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetRemoteMissionEligibilityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRemoteMissionEligibilityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        data["branchId"] = this.branchId;
        data["canAccept"] = this.canAccept;
        data["status"] = this.status;
        data["hardLimitReached"] = this.hardLimitReached;
        data["verifyUserPhoneNumber"] = this.verifyUserPhoneNumber;
        data["ageRestrictionType"] = this.ageRestrictionType;
        data["requiresAdultIdVerification"] = this.requiresAdultIdVerification;
        data["requiresRelatedMinorSelection"] = this.requiresRelatedMinorSelection;
        if (Array.isArray(this.eligibleRelatedMinors)) {
            data["eligibleRelatedMinors"] = [];
            for (let item of this.eligibleRelatedMinors)
                data["eligibleRelatedMinors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.missingProfileMembers)) {
            data["missingProfileMembers"] = [];
            for (let item of this.missingProfileMembers)
                data["missingProfileMembers"].push(item ? item.toJSON() : undefined as any);
        }
        data["rotationInfo"] = this.rotationInfo ? this.rotationInfo.toJSON() : undefined as any;
        return data;
    }
}

export enum AgeRestrictionType {
    Minor = 10,
    Adult = 20,
}

export class EligibleRelatedMinorDto {
    id?: string;
    firstName?: string;
    lastName?: string;
    gender?: RelatedMinorGender;
    birthDate?: Date;
    relationship?: RelatedMinorRelationship;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gender = _data["gender"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined as any;
            this.relationship = _data["relationship"];
        }
    }

    static fromJS(data: any): EligibleRelatedMinorDto {
        data = typeof data === 'object' ? data : {};
        let result = new EligibleRelatedMinorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gender"] = this.gender;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined as any;
        data["relationship"] = this.relationship;
        return data;
    }
}

export enum RelatedMinorGender {
    Male = 10,
    Female = 20,
    NonBinary = 30,
}

export enum RelatedMinorRelationship {
    Child = 10,
    Sibling = 20,
    LegalGuardian = 30,
    OtherRelatedFamily = 40,
}

export class AcceptRemoteMissionResponse {
    scenarioUpdateNotice?: ScenarioUpdateNoticeDto | undefined;
    success?: boolean;
    missionEndDate?: Date | undefined;
    acceptMissionStatus?: AcceptMissionStatus;
    hardLimitReached?: boolean;
    verifyUserPhoneNumber?: boolean | undefined;
    missionAssignationId?: string | undefined;
    geolocationRequirement?: GeolocationRequirement;
    geolocationRadiusMeters?: number | undefined;
    rotationInfo?: AcceptMissionRotationInfoDto | undefined;
    ageRestrictionType?: AgeRestrictionType | undefined;
    requiresRelatedMinorSelection?: boolean;
    eligibleRelatedMinors?: EligibleRelatedMinorDto[];
    missingProfileMembers?: GetMysteryShopperProfileMemberDto[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.scenarioUpdateNotice = _data["scenarioUpdateNotice"] ? ScenarioUpdateNoticeDto.fromJS(_data["scenarioUpdateNotice"]) : undefined as any;
            this.success = _data["success"];
            this.missionEndDate = _data["missionEndDate"] ? new Date(_data["missionEndDate"].toString()) : undefined as any;
            this.acceptMissionStatus = _data["acceptMissionStatus"];
            this.hardLimitReached = _data["hardLimitReached"];
            this.verifyUserPhoneNumber = _data["verifyUserPhoneNumber"];
            this.missionAssignationId = _data["missionAssignationId"];
            this.geolocationRequirement = _data["geolocationRequirement"];
            this.geolocationRadiusMeters = _data["geolocationRadiusMeters"];
            this.rotationInfo = _data["rotationInfo"] ? AcceptMissionRotationInfoDto.fromJS(_data["rotationInfo"]) : undefined as any;
            this.ageRestrictionType = _data["ageRestrictionType"];
            this.requiresRelatedMinorSelection = _data["requiresRelatedMinorSelection"];
            if (Array.isArray(_data["eligibleRelatedMinors"])) {
                this.eligibleRelatedMinors = [] as any;
                for (let item of _data["eligibleRelatedMinors"])
                    this.eligibleRelatedMinors!.push(EligibleRelatedMinorDto.fromJS(item));
            }
            if (Array.isArray(_data["missingProfileMembers"])) {
                this.missingProfileMembers = [] as any;
                for (let item of _data["missingProfileMembers"])
                    this.missingProfileMembers!.push(GetMysteryShopperProfileMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AcceptRemoteMissionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptRemoteMissionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioUpdateNotice"] = this.scenarioUpdateNotice ? this.scenarioUpdateNotice.toJSON() : undefined as any;
        data["success"] = this.success;
        data["missionEndDate"] = this.missionEndDate ? this.missionEndDate.toISOString() : undefined as any;
        data["acceptMissionStatus"] = this.acceptMissionStatus;
        data["hardLimitReached"] = this.hardLimitReached;
        data["verifyUserPhoneNumber"] = this.verifyUserPhoneNumber;
        data["missionAssignationId"] = this.missionAssignationId;
        data["geolocationRequirement"] = this.geolocationRequirement;
        data["geolocationRadiusMeters"] = this.geolocationRadiusMeters;
        data["rotationInfo"] = this.rotationInfo ? this.rotationInfo.toJSON() : undefined as any;
        data["ageRestrictionType"] = this.ageRestrictionType;
        data["requiresRelatedMinorSelection"] = this.requiresRelatedMinorSelection;
        if (Array.isArray(this.eligibleRelatedMinors)) {
            data["eligibleRelatedMinors"] = [];
            for (let item of this.eligibleRelatedMinors)
                data["eligibleRelatedMinors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.missingProfileMembers)) {
            data["missingProfileMembers"] = [];
            for (let item of this.missingProfileMembers)
                data["missingProfileMembers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export enum GeolocationRequirement {
    No = 0,
    Optional = 1,
    Required = 2,
}

export class AcceptRemoteMissionRequest {
    scenarioReviewCompleted?: boolean;
    branchId?: string | undefined;
    startDate?: Date | undefined;
    selectedRelatedMinorId?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.scenarioReviewCompleted = _data["scenarioReviewCompleted"];
            this.branchId = _data["branchId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.selectedRelatedMinorId = _data["selectedRelatedMinorId"];
        }
    }

    static fromJS(data: any): AcceptRemoteMissionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptRemoteMissionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioReviewCompleted"] = this.scenarioReviewCompleted;
        data["branchId"] = this.branchId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["selectedRelatedMinorId"] = this.selectedRelatedMinorId;
        return data;
    }
}

export class GetAirportMissionZonesViewModel {
    zones?: GetAirportMissionZoneDto[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["zones"])) {
                this.zones = [] as any;
                for (let item of _data["zones"])
                    this.zones!.push(GetAirportMissionZoneDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAirportMissionZonesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAirportMissionZonesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.zones)) {
            data["zones"] = [];
            for (let item of this.zones)
                data["zones"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class GetAirportMissionZoneDto {
    zoneId?: string;
    name?: string;

    init(_data?: any) {
        if (_data) {
            this.zoneId = _data["zoneId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetAirportMissionZoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAirportMissionZoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoneId"] = this.zoneId;
        data["name"] = this.name;
        return data;
    }
}

export class GetMissionsViewModel {
    highOrderMissions?: GetMissionsFromMapDto[];
    missions?: GetMissionsFromMapDto[];
    lowOrderMissions?: GetMissionsFromMapDto[];
    tags?: GetMissionsTagDto[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["highOrderMissions"])) {
                this.highOrderMissions = [] as any;
                for (let item of _data["highOrderMissions"])
                    this.highOrderMissions!.push(GetMissionsFromMapDto.fromJS(item));
            }
            if (Array.isArray(_data["missions"])) {
                this.missions = [] as any;
                for (let item of _data["missions"])
                    this.missions!.push(GetMissionsFromMapDto.fromJS(item));
            }
            if (Array.isArray(_data["lowOrderMissions"])) {
                this.lowOrderMissions = [] as any;
                for (let item of _data["lowOrderMissions"])
                    this.lowOrderMissions!.push(GetMissionsFromMapDto.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(GetMissionsTagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMissionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.highOrderMissions)) {
            data["highOrderMissions"] = [];
            for (let item of this.highOrderMissions)
                data["highOrderMissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.missions)) {
            data["missions"] = [];
            for (let item of this.missions)
                data["missions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lowOrderMissions)) {
            data["lowOrderMissions"] = [];
            for (let item of this.lowOrderMissions)
                data["lowOrderMissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class GetMissionsFromMapDto {
    missionOrder?: MissionOrderType | undefined;
    branchId?: string;
    listingKey?: string | undefined;
    periodMissionConfigurationIds?: string[] | undefined;
    promotionDisplay?: MissionPromotionDisplayDto | undefined;
    isPinned?: boolean;
    name?: string;
    phone?: string;
    hasLogo?: boolean;
    logoUrl?: string | undefined;
    svgIcon?: string | undefined;
    address?: string;
    distance?: number;
    tags?: string;
    tagCount?: number;
    canAccept?: boolean;
    isAvailableForDiscovery?: boolean;
    discoveryAvailabilityStatus?: MissionDiscoveryAvailabilityStatus;
    isHidden?: boolean;
    missionType?: MissionType;
    isFlashMission?: boolean;
    hasAgeRestrictedMissions?: boolean;
    upcomingPeriod?: boolean;
    upcomingPeriodStartDate?: Date | undefined;
    isCompetitorCircuit?: boolean;
    competitorLocations?: CompetitorCircuitPreviewLocationDto[];
    branchAirportInfo?: MissionBranchAirportInfoDto | undefined;
    geocoordinate?: GeoLocation;
    referenceLocation?: GeoLocation | undefined;
    missionConfigurationNames?: string[];

    init(_data?: any) {
        if (_data) {
            this.missionOrder = _data["missionOrder"];
            this.branchId = _data["branchId"];
            this.listingKey = _data["listingKey"];
            if (Array.isArray(_data["periodMissionConfigurationIds"])) {
                this.periodMissionConfigurationIds = [] as any;
                for (let item of _data["periodMissionConfigurationIds"])
                    this.periodMissionConfigurationIds!.push(item);
            }
            this.promotionDisplay = _data["promotionDisplay"] ? MissionPromotionDisplayDto.fromJS(_data["promotionDisplay"]) : undefined as any;
            this.isPinned = _data["isPinned"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.hasLogo = _data["hasLogo"];
            this.logoUrl = _data["logoUrl"];
            this.svgIcon = _data["svgIcon"];
            this.address = _data["address"];
            this.distance = _data["distance"];
            this.tags = _data["tags"];
            this.tagCount = _data["tagCount"];
            this.canAccept = _data["canAccept"];
            this.isAvailableForDiscovery = _data["isAvailableForDiscovery"];
            this.discoveryAvailabilityStatus = _data["discoveryAvailabilityStatus"];
            this.isHidden = _data["isHidden"];
            this.missionType = _data["missionType"];
            this.isFlashMission = _data["isFlashMission"];
            this.hasAgeRestrictedMissions = _data["hasAgeRestrictedMissions"];
            this.upcomingPeriod = _data["upcomingPeriod"];
            this.upcomingPeriodStartDate = _data["upcomingPeriodStartDate"] ? new Date(_data["upcomingPeriodStartDate"].toString()) : undefined as any;
            this.isCompetitorCircuit = _data["isCompetitorCircuit"];
            if (Array.isArray(_data["competitorLocations"])) {
                this.competitorLocations = [] as any;
                for (let item of _data["competitorLocations"])
                    this.competitorLocations!.push(CompetitorCircuitPreviewLocationDto.fromJS(item));
            }
            this.branchAirportInfo = _data["branchAirportInfo"] ? MissionBranchAirportInfoDto.fromJS(_data["branchAirportInfo"]) : undefined as any;
            this.geocoordinate = _data["geocoordinate"] ? GeoLocation.fromJS(_data["geocoordinate"]) : undefined as any;
            this.referenceLocation = _data["referenceLocation"] ? GeoLocation.fromJS(_data["referenceLocation"]) : undefined as any;
            if (Array.isArray(_data["missionConfigurationNames"])) {
                this.missionConfigurationNames = [] as any;
                for (let item of _data["missionConfigurationNames"])
                    this.missionConfigurationNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetMissionsFromMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionsFromMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionOrder"] = this.missionOrder;
        data["branchId"] = this.branchId;
        data["listingKey"] = this.listingKey;
        if (Array.isArray(this.periodMissionConfigurationIds)) {
            data["periodMissionConfigurationIds"] = [];
            for (let item of this.periodMissionConfigurationIds)
                data["periodMissionConfigurationIds"].push(item);
        }
        data["promotionDisplay"] = this.promotionDisplay ? this.promotionDisplay.toJSON() : undefined as any;
        data["isPinned"] = this.isPinned;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["hasLogo"] = this.hasLogo;
        data["logoUrl"] = this.logoUrl;
        data["svgIcon"] = this.svgIcon;
        data["address"] = this.address;
        data["distance"] = this.distance;
        data["tags"] = this.tags;
        data["tagCount"] = this.tagCount;
        data["canAccept"] = this.canAccept;
        data["isAvailableForDiscovery"] = this.isAvailableForDiscovery;
        data["discoveryAvailabilityStatus"] = this.discoveryAvailabilityStatus;
        data["isHidden"] = this.isHidden;
        data["missionType"] = this.missionType;
        data["isFlashMission"] = this.isFlashMission;
        data["hasAgeRestrictedMissions"] = this.hasAgeRestrictedMissions;
        data["upcomingPeriod"] = this.upcomingPeriod;
        data["upcomingPeriodStartDate"] = this.upcomingPeriodStartDate ? this.upcomingPeriodStartDate.toISOString() : undefined as any;
        data["isCompetitorCircuit"] = this.isCompetitorCircuit;
        if (Array.isArray(this.competitorLocations)) {
            data["competitorLocations"] = [];
            for (let item of this.competitorLocations)
                data["competitorLocations"].push(item ? item.toJSON() : undefined as any);
        }
        data["branchAirportInfo"] = this.branchAirportInfo ? this.branchAirportInfo.toJSON() : undefined as any;
        data["geocoordinate"] = this.geocoordinate ? this.geocoordinate.toJSON() : undefined as any;
        data["referenceLocation"] = this.referenceLocation ? this.referenceLocation.toJSON() : undefined as any;
        if (Array.isArray(this.missionConfigurationNames)) {
            data["missionConfigurationNames"] = [];
            for (let item of this.missionConfigurationNames)
                data["missionConfigurationNames"].push(item);
        }
        return data;
    }
}

export enum MissionOrderType {
    Top = 0,
    Bottom = 1,
}

export class GetMissionsTagDto {
    id?: string;
    name?: string;
    svgIcon?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.svgIcon = _data["svgIcon"];
        }
    }

    static fromJS(data: any): GetMissionsTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionsTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["svgIcon"] = this.svgIcon;
        return data;
    }
}

export enum AirportVisitType {
    Departing = 0,
    PickupDropoff = 1,
    Arriving = 2,
}

export class GetMissionsFromMapResponse {
    highOrderMissions?: GetMissionsFromMapDto[];
    missions?: GetMissionsFromMapDto[];
    lowOrderMissions?: GetMissionsFromMapDto[];
    tags?: GetMissionsTagDto[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["highOrderMissions"])) {
                this.highOrderMissions = [] as any;
                for (let item of _data["highOrderMissions"])
                    this.highOrderMissions!.push(GetMissionsFromMapDto.fromJS(item));
            }
            if (Array.isArray(_data["missions"])) {
                this.missions = [] as any;
                for (let item of _data["missions"])
                    this.missions!.push(GetMissionsFromMapDto.fromJS(item));
            }
            if (Array.isArray(_data["lowOrderMissions"])) {
                this.lowOrderMissions = [] as any;
                for (let item of _data["lowOrderMissions"])
                    this.lowOrderMissions!.push(GetMissionsFromMapDto.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(GetMissionsTagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMissionsFromMapResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionsFromMapResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.highOrderMissions)) {
            data["highOrderMissions"] = [];
            for (let item of this.highOrderMissions)
                data["highOrderMissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.missions)) {
            data["missions"] = [];
            for (let item of this.missions)
                data["missions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lowOrderMissions)) {
            data["lowOrderMissions"] = [];
            for (let item of this.lowOrderMissions)
                data["lowOrderMissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class GetAirportMissionsFromMapResponse {
    airports?: GetAirportMapGroupDto[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["airports"])) {
                this.airports = [] as any;
                for (let item of _data["airports"])
                    this.airports!.push(GetAirportMapGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAirportMissionsFromMapResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAirportMissionsFromMapResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.airports)) {
            data["airports"] = [];
            for (let item of this.airports)
                data["airports"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class GetAirportMapGroupDto {
    airportId?: string;
    airportName?: string;
    geocoordinate?: GeoLocation;
    missionCount?: number;
    representativeBranchId?: string;
    highOrderMissions?: GetMissionsFromMapDto[];
    missions?: GetMissionsFromMapDto[];
    lowOrderMissions?: GetMissionsFromMapDto[];
    tags?: GetMissionsTagDto[];
    routeOptions?: GetAirportRouteOptionDto[];

    init(_data?: any) {
        if (_data) {
            this.airportId = _data["airportId"];
            this.airportName = _data["airportName"];
            this.geocoordinate = _data["geocoordinate"] ? GeoLocation.fromJS(_data["geocoordinate"]) : undefined as any;
            this.missionCount = _data["missionCount"];
            this.representativeBranchId = _data["representativeBranchId"];
            if (Array.isArray(_data["highOrderMissions"])) {
                this.highOrderMissions = [] as any;
                for (let item of _data["highOrderMissions"])
                    this.highOrderMissions!.push(GetMissionsFromMapDto.fromJS(item));
            }
            if (Array.isArray(_data["missions"])) {
                this.missions = [] as any;
                for (let item of _data["missions"])
                    this.missions!.push(GetMissionsFromMapDto.fromJS(item));
            }
            if (Array.isArray(_data["lowOrderMissions"])) {
                this.lowOrderMissions = [] as any;
                for (let item of _data["lowOrderMissions"])
                    this.lowOrderMissions!.push(GetMissionsFromMapDto.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(GetMissionsTagDto.fromJS(item));
            }
            if (Array.isArray(_data["routeOptions"])) {
                this.routeOptions = [] as any;
                for (let item of _data["routeOptions"])
                    this.routeOptions!.push(GetAirportRouteOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAirportMapGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAirportMapGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airportId"] = this.airportId;
        data["airportName"] = this.airportName;
        data["geocoordinate"] = this.geocoordinate ? this.geocoordinate.toJSON() : undefined as any;
        data["missionCount"] = this.missionCount;
        data["representativeBranchId"] = this.representativeBranchId;
        if (Array.isArray(this.highOrderMissions)) {
            data["highOrderMissions"] = [];
            for (let item of this.highOrderMissions)
                data["highOrderMissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.missions)) {
            data["missions"] = [];
            for (let item of this.missions)
                data["missions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lowOrderMissions)) {
            data["lowOrderMissions"] = [];
            for (let item of this.lowOrderMissions)
                data["lowOrderMissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.routeOptions)) {
            data["routeOptions"] = [];
            for (let item of this.routeOptions)
                data["routeOptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class GetAirportRouteOptionDto {
    zoneId?: string;
    name?: string;

    init(_data?: any) {
        if (_data) {
            this.zoneId = _data["zoneId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetAirportRouteOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAirportRouteOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoneId"] = this.zoneId;
        data["name"] = this.name;
        return data;
    }
}

export class GetAcceptMissionsFromMapViewModel {
    items?: GetAcceptMissionsFromMapDto[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAcceptMissionsFromMapDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAcceptMissionsFromMapViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAcceptMissionsFromMapViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class GetAcceptMissionsFromMapDto {
    branchId?: string;
    canAccept?: boolean;

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"];
            this.canAccept = _data["canAccept"];
        }
    }

    static fromJS(data: any): GetAcceptMissionsFromMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAcceptMissionsFromMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["canAccept"] = this.canAccept;
        return data;
    }
}

export class GetAcceptMissionViewModel {
    acceptMissionStatus?: AcceptMissionStatus;
    missionAssignationId?: string | undefined;
    rotationInfo?: AcceptMissionRotationInfoDto | undefined;
    ageRestrictionType?: AgeRestrictionType | undefined;
    requiresRelatedMinorSelection?: boolean;
    eligibleRelatedMinors?: EligibleRelatedMinorDto[];
    missingProfileMembers?: GetMysteryShopperProfileMemberDto[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.acceptMissionStatus = _data["acceptMissionStatus"];
            this.missionAssignationId = _data["missionAssignationId"];
            this.rotationInfo = _data["rotationInfo"] ? AcceptMissionRotationInfoDto.fromJS(_data["rotationInfo"]) : undefined as any;
            this.ageRestrictionType = _data["ageRestrictionType"];
            this.requiresRelatedMinorSelection = _data["requiresRelatedMinorSelection"];
            if (Array.isArray(_data["eligibleRelatedMinors"])) {
                this.eligibleRelatedMinors = [] as any;
                for (let item of _data["eligibleRelatedMinors"])
                    this.eligibleRelatedMinors!.push(EligibleRelatedMinorDto.fromJS(item));
            }
            if (Array.isArray(_data["missingProfileMembers"])) {
                this.missingProfileMembers = [] as any;
                for (let item of _data["missingProfileMembers"])
                    this.missingProfileMembers!.push(GetMysteryShopperProfileMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAcceptMissionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAcceptMissionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acceptMissionStatus"] = this.acceptMissionStatus;
        data["missionAssignationId"] = this.missionAssignationId;
        data["rotationInfo"] = this.rotationInfo ? this.rotationInfo.toJSON() : undefined as any;
        data["ageRestrictionType"] = this.ageRestrictionType;
        data["requiresRelatedMinorSelection"] = this.requiresRelatedMinorSelection;
        if (Array.isArray(this.eligibleRelatedMinors)) {
            data["eligibleRelatedMinors"] = [];
            for (let item of this.eligibleRelatedMinors)
                data["eligibleRelatedMinors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.missingProfileMembers)) {
            data["missingProfileMembers"] = [];
            for (let item of this.missingProfileMembers)
                data["missingProfileMembers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class GetAcceptMissionByBranchViewModel {
    items?: GetAcceptMissionByBranchDto[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAcceptMissionByBranchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAcceptMissionByBranchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAcceptMissionByBranchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class GetAcceptMissionByBranchDto {
    periodMissionConfigurationId?: string;
    acceptMissionStatus?: AcceptMissionStatus;
    missionAssignationId?: string | undefined;
    rotationInfo?: AcceptMissionRotationInfoDto | undefined;
    isReferable?: boolean;
    ageRestrictionType?: AgeRestrictionType | undefined;
    requiresRelatedMinorSelection?: boolean;
    eligibleRelatedMinors?: EligibleRelatedMinorDto[];
    missingProfileMembers?: GetMysteryShopperProfileMemberDto[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            this.acceptMissionStatus = _data["acceptMissionStatus"];
            this.missionAssignationId = _data["missionAssignationId"];
            this.rotationInfo = _data["rotationInfo"] ? AcceptMissionRotationInfoDto.fromJS(_data["rotationInfo"]) : undefined as any;
            this.isReferable = _data["isReferable"];
            this.ageRestrictionType = _data["ageRestrictionType"];
            this.requiresRelatedMinorSelection = _data["requiresRelatedMinorSelection"];
            if (Array.isArray(_data["eligibleRelatedMinors"])) {
                this.eligibleRelatedMinors = [] as any;
                for (let item of _data["eligibleRelatedMinors"])
                    this.eligibleRelatedMinors!.push(EligibleRelatedMinorDto.fromJS(item));
            }
            if (Array.isArray(_data["missingProfileMembers"])) {
                this.missingProfileMembers = [] as any;
                for (let item of _data["missingProfileMembers"])
                    this.missingProfileMembers!.push(GetMysteryShopperProfileMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAcceptMissionByBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAcceptMissionByBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        data["acceptMissionStatus"] = this.acceptMissionStatus;
        data["missionAssignationId"] = this.missionAssignationId;
        data["rotationInfo"] = this.rotationInfo ? this.rotationInfo.toJSON() : undefined as any;
        data["isReferable"] = this.isReferable;
        data["ageRestrictionType"] = this.ageRestrictionType;
        data["requiresRelatedMinorSelection"] = this.requiresRelatedMinorSelection;
        if (Array.isArray(this.eligibleRelatedMinors)) {
            data["eligibleRelatedMinors"] = [];
            for (let item of this.eligibleRelatedMinors)
                data["eligibleRelatedMinors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.missingProfileMembers)) {
            data["missingProfileMembers"] = [];
            for (let item of this.missingProfileMembers)
                data["missingProfileMembers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class AcceptMissionResponse {
    scenarioUpdateNotice?: ScenarioUpdateNoticeDto | undefined;
    success?: boolean;
    missionEndDate?: Date | undefined;
    acceptMissionStatus?: AcceptMissionStatus;
    hardLimitReached?: boolean;
    verifyUserPhoneNumber?: boolean | undefined;
    missionAssignationId?: string | undefined;
    geolocationRequirement?: GeolocationRequirement;
    geolocationRadiusMeters?: number | undefined;
    rotationInfo?: AcceptMissionRotationInfoDto | undefined;
    ageRestrictionType?: AgeRestrictionType | undefined;
    requiresRelatedMinorSelection?: boolean;
    eligibleRelatedMinors?: EligibleRelatedMinorDto[];
    missingProfileMembers?: GetMysteryShopperProfileMemberDto[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.scenarioUpdateNotice = _data["scenarioUpdateNotice"] ? ScenarioUpdateNoticeDto.fromJS(_data["scenarioUpdateNotice"]) : undefined as any;
            this.success = _data["success"];
            this.missionEndDate = _data["missionEndDate"] ? new Date(_data["missionEndDate"].toString()) : undefined as any;
            this.acceptMissionStatus = _data["acceptMissionStatus"];
            this.hardLimitReached = _data["hardLimitReached"];
            this.verifyUserPhoneNumber = _data["verifyUserPhoneNumber"];
            this.missionAssignationId = _data["missionAssignationId"];
            this.geolocationRequirement = _data["geolocationRequirement"];
            this.geolocationRadiusMeters = _data["geolocationRadiusMeters"];
            this.rotationInfo = _data["rotationInfo"] ? AcceptMissionRotationInfoDto.fromJS(_data["rotationInfo"]) : undefined as any;
            this.ageRestrictionType = _data["ageRestrictionType"];
            this.requiresRelatedMinorSelection = _data["requiresRelatedMinorSelection"];
            if (Array.isArray(_data["eligibleRelatedMinors"])) {
                this.eligibleRelatedMinors = [] as any;
                for (let item of _data["eligibleRelatedMinors"])
                    this.eligibleRelatedMinors!.push(EligibleRelatedMinorDto.fromJS(item));
            }
            if (Array.isArray(_data["missingProfileMembers"])) {
                this.missingProfileMembers = [] as any;
                for (let item of _data["missingProfileMembers"])
                    this.missingProfileMembers!.push(GetMysteryShopperProfileMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AcceptMissionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptMissionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioUpdateNotice"] = this.scenarioUpdateNotice ? this.scenarioUpdateNotice.toJSON() : undefined as any;
        data["success"] = this.success;
        data["missionEndDate"] = this.missionEndDate ? this.missionEndDate.toISOString() : undefined as any;
        data["acceptMissionStatus"] = this.acceptMissionStatus;
        data["hardLimitReached"] = this.hardLimitReached;
        data["verifyUserPhoneNumber"] = this.verifyUserPhoneNumber;
        data["missionAssignationId"] = this.missionAssignationId;
        data["geolocationRequirement"] = this.geolocationRequirement;
        data["geolocationRadiusMeters"] = this.geolocationRadiusMeters;
        data["rotationInfo"] = this.rotationInfo ? this.rotationInfo.toJSON() : undefined as any;
        data["ageRestrictionType"] = this.ageRestrictionType;
        data["requiresRelatedMinorSelection"] = this.requiresRelatedMinorSelection;
        if (Array.isArray(this.eligibleRelatedMinors)) {
            data["eligibleRelatedMinors"] = [];
            for (let item of this.eligibleRelatedMinors)
                data["eligibleRelatedMinors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.missingProfileMembers)) {
            data["missingProfileMembers"] = [];
            for (let item of this.missingProfileMembers)
                data["missingProfileMembers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class CreateMissionReferralResponse {
    success?: boolean;
    status?: CreateMissionReferralStatus;
    missionReferralId?: string | undefined;
    missionAssignationId?: string | undefined;
    referralUrl?: string | undefined;
    expiresAt?: Date | undefined;
    emailRequested?: boolean;
    emailSent?: boolean;
    emailMessageId?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
            this.missionReferralId = _data["missionReferralId"];
            this.missionAssignationId = _data["missionAssignationId"];
            this.referralUrl = _data["referralUrl"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : undefined as any;
            this.emailRequested = _data["emailRequested"];
            this.emailSent = _data["emailSent"];
            this.emailMessageId = _data["emailMessageId"];
        }
    }

    static fromJS(data: any): CreateMissionReferralResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMissionReferralResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        data["missionReferralId"] = this.missionReferralId;
        data["missionAssignationId"] = this.missionAssignationId;
        data["referralUrl"] = this.referralUrl;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : undefined as any;
        data["emailRequested"] = this.emailRequested;
        data["emailSent"] = this.emailSent;
        data["emailMessageId"] = this.emailMessageId;
        return data;
    }
}

export enum CreateMissionReferralStatus {
    InvitationSent = 0,
    MissionUnavailable = 1,
    Retry = 2,
    SenderIneligible = 3,
    MonthlyReferralLimitReached = 4,
}

export class CreateMissionReferralRequest {
    periodMissionConfigurationId?: string;
    branchId?: string;
    invitedEmail?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            this.branchId = _data["branchId"];
            this.invitedEmail = _data["invitedEmail"];
        }
    }

    static fromJS(data: any): CreateMissionReferralRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMissionReferralRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        data["branchId"] = this.branchId;
        data["invitedEmail"] = this.invitedEmail;
        return data;
    }
}

export class GetMissionReferralListResponse {
    referrals?: GetMissionReferralListGroupDto[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["referrals"])) {
                this.referrals = [] as any;
                for (let item of _data["referrals"])
                    this.referrals!.push(GetMissionReferralListGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMissionReferralListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionReferralListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.referrals)) {
            data["referrals"] = [];
            for (let item of this.referrals)
                data["referrals"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class GetMissionReferralListGroupDto {
    group?: MissionReferralListGroup;
    missionsList?: GetMissionReferralListDto[];

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"];
            if (Array.isArray(_data["missionsList"])) {
                this.missionsList = [] as any;
                for (let item of _data["missionsList"])
                    this.missionsList!.push(GetMissionReferralListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMissionReferralListGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionReferralListGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group;
        if (Array.isArray(this.missionsList)) {
            data["missionsList"] = [];
            for (let item of this.missionsList)
                data["missionsList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export enum MissionReferralListGroup {
    Sent = 0,
    Approved = 1,
}

export class GetMissionReferralListDto {
    missionReferralId?: string;
    missionAssignationId?: string;
    periodMissionConfigurationId?: string;
    branchId?: string;
    referralStatus?: MissionReferralStatus;
    missionAssignationStatus?: MissionAssignationStatus;
    invitedEmail?: string | undefined;
    hasInvitedEmail?: boolean;
    sentAt?: Date;
    expiresAt?: Date;
    acceptedAt?: Date | undefined;
    approvedDate?: Date | undefined;
    canResend?: boolean;
    canRemindFriend?: boolean;
    canCancel?: boolean;
    name?: string;
    phone?: string;
    hasLogo?: boolean;
    logoUrl?: string | undefined;
    address?: string;
    missionConfigurationName?: string;
    geoLocation?: GeoLocation;
    missionType?: MissionType;
    isFlashMission?: boolean;

    init(_data?: any) {
        if (_data) {
            this.missionReferralId = _data["missionReferralId"];
            this.missionAssignationId = _data["missionAssignationId"];
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            this.branchId = _data["branchId"];
            this.referralStatus = _data["referralStatus"];
            this.missionAssignationStatus = _data["missionAssignationStatus"];
            this.invitedEmail = _data["invitedEmail"];
            this.hasInvitedEmail = _data["hasInvitedEmail"];
            this.sentAt = _data["sentAt"] ? new Date(_data["sentAt"].toString()) : undefined as any;
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : undefined as any;
            this.acceptedAt = _data["acceptedAt"] ? new Date(_data["acceptedAt"].toString()) : undefined as any;
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : undefined as any;
            this.canResend = _data["canResend"];
            this.canRemindFriend = _data["canRemindFriend"];
            this.canCancel = _data["canCancel"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.hasLogo = _data["hasLogo"];
            this.logoUrl = _data["logoUrl"];
            this.address = _data["address"];
            this.missionConfigurationName = _data["missionConfigurationName"];
            this.geoLocation = _data["geoLocation"] ? GeoLocation.fromJS(_data["geoLocation"]) : undefined as any;
            this.missionType = _data["missionType"];
            this.isFlashMission = _data["isFlashMission"];
        }
    }

    static fromJS(data: any): GetMissionReferralListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionReferralListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionReferralId"] = this.missionReferralId;
        data["missionAssignationId"] = this.missionAssignationId;
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        data["branchId"] = this.branchId;
        data["referralStatus"] = this.referralStatus;
        data["missionAssignationStatus"] = this.missionAssignationStatus;
        data["invitedEmail"] = this.invitedEmail;
        data["hasInvitedEmail"] = this.hasInvitedEmail;
        data["sentAt"] = this.sentAt ? this.sentAt.toISOString() : undefined as any;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : undefined as any;
        data["acceptedAt"] = this.acceptedAt ? this.acceptedAt.toISOString() : undefined as any;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : undefined as any;
        data["canResend"] = this.canResend;
        data["canRemindFriend"] = this.canRemindFriend;
        data["canCancel"] = this.canCancel;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["hasLogo"] = this.hasLogo;
        data["logoUrl"] = this.logoUrl;
        data["address"] = this.address;
        data["missionConfigurationName"] = this.missionConfigurationName;
        data["geoLocation"] = this.geoLocation ? this.geoLocation.toJSON() : undefined as any;
        data["missionType"] = this.missionType;
        data["isFlashMission"] = this.isFlashMission;
        return data;
    }
}

export enum MissionReferralStatus {
    InvitationSent = 0,
    InvitationAccepted = 1,
    InvitationCanceled = 2,
}

export enum MissionAssignationStatus {
    Available = 0,
    Assigned = 1,
    Prevalidation = 2,
    Validating = 3,
    ValidationRejected = 4,
    Approved = 5,
    Cancelled = 6,
    FraudDetected = 7,
    InappropriateLanguage = 8,
    ApproveDeactivated = 9,
    Imported = 10,
    ExpiredTimeout = 11,
    ExpiredCorrection = 12,
    PrevalidationFailed = 13,
    LLMApproved = 14,
    LLMRejected = 15,
    Referred = 16,
    NotReleased = -1,
}

export class GetMissionReferralDetailsResponse {
    missionReferralId?: string;
    missionAssignationId?: string;
    periodMissionConfigurationId?: string;
    branchId?: string;
    referralStatus?: MissionReferralStatus;
    missionAssignationStatus?: MissionAssignationStatus;
    invitedEmail?: string | undefined;
    hasInvitedEmail?: boolean;
    sentAt?: Date;
    expiresAt?: Date;
    acceptedAt?: Date | undefined;
    approvedDate?: Date | undefined;
    canceledAt?: Date | undefined;
    canCancelReference?: boolean;
    canRemindFriend?: boolean;
    referenceLink?: string | undefined;
    missionDetails?: GetMissionReferralMissionDetailsDto;

    init(_data?: any) {
        if (_data) {
            this.missionReferralId = _data["missionReferralId"];
            this.missionAssignationId = _data["missionAssignationId"];
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            this.branchId = _data["branchId"];
            this.referralStatus = _data["referralStatus"];
            this.missionAssignationStatus = _data["missionAssignationStatus"];
            this.invitedEmail = _data["invitedEmail"];
            this.hasInvitedEmail = _data["hasInvitedEmail"];
            this.sentAt = _data["sentAt"] ? new Date(_data["sentAt"].toString()) : undefined as any;
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : undefined as any;
            this.acceptedAt = _data["acceptedAt"] ? new Date(_data["acceptedAt"].toString()) : undefined as any;
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : undefined as any;
            this.canceledAt = _data["canceledAt"] ? new Date(_data["canceledAt"].toString()) : undefined as any;
            this.canCancelReference = _data["canCancelReference"];
            this.canRemindFriend = _data["canRemindFriend"];
            this.referenceLink = _data["referenceLink"];
            this.missionDetails = _data["missionDetails"] ? GetMissionReferralMissionDetailsDto.fromJS(_data["missionDetails"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetMissionReferralDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionReferralDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionReferralId"] = this.missionReferralId;
        data["missionAssignationId"] = this.missionAssignationId;
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        data["branchId"] = this.branchId;
        data["referralStatus"] = this.referralStatus;
        data["missionAssignationStatus"] = this.missionAssignationStatus;
        data["invitedEmail"] = this.invitedEmail;
        data["hasInvitedEmail"] = this.hasInvitedEmail;
        data["sentAt"] = this.sentAt ? this.sentAt.toISOString() : undefined as any;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : undefined as any;
        data["acceptedAt"] = this.acceptedAt ? this.acceptedAt.toISOString() : undefined as any;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : undefined as any;
        data["canceledAt"] = this.canceledAt ? this.canceledAt.toISOString() : undefined as any;
        data["canCancelReference"] = this.canCancelReference;
        data["canRemindFriend"] = this.canRemindFriend;
        data["referenceLink"] = this.referenceLink;
        data["missionDetails"] = this.missionDetails ? this.missionDetails.toJSON() : undefined as any;
        return data;
    }
}

export class GetMissionReferralMissionDetailsDto {
    scenarioUpdateNotice?: ScenarioUpdateNoticeDto | undefined;
    promotionDisplay?: MissionPromotionDisplayDto | undefined;
    periodStartDate?: Date | undefined;
    periodEndDate?: Date | undefined;
    name?: string;
    missionConfigurationName?: string;
    time?: string;
    phone?: string | undefined;
    hasLogo?: boolean;
    logoUrl?: string | undefined;
    address?: string;
    tags?: string;
    reimbursementValue?: string | undefined;
    reimbursementMaxAmount?: number | undefined;
    reimbursementMaxPoints?: number | undefined;
    salaryAmount?: number | undefined;
    salaryPoints?: number | undefined;
    requiredPurchase?: boolean;
    requiredPurchaseText?: string | undefined;
    requiredPurchaseExclusionText?: string | undefined;
    supportedCultureCodes?: string[] | undefined;
    storeLocatorLink?: string | undefined;
    missionType?: MissionType;
    isFlashMission?: boolean;
    geoLocation?: GeoLocation;
    branchAirportInfo?: MissionBranchAirportInfoDto | undefined;
    selectedRelatedMinor?: EligibleRelatedMinorDto | undefined;
    details?: MissionDetailsDto[];

    init(_data?: any) {
        if (_data) {
            this.scenarioUpdateNotice = _data["scenarioUpdateNotice"] ? ScenarioUpdateNoticeDto.fromJS(_data["scenarioUpdateNotice"]) : undefined as any;
            this.promotionDisplay = _data["promotionDisplay"] ? MissionPromotionDisplayDto.fromJS(_data["promotionDisplay"]) : undefined as any;
            this.periodStartDate = _data["periodStartDate"] ? new Date(_data["periodStartDate"].toString()) : undefined as any;
            this.periodEndDate = _data["periodEndDate"] ? new Date(_data["periodEndDate"].toString()) : undefined as any;
            this.name = _data["name"];
            this.missionConfigurationName = _data["missionConfigurationName"];
            this.time = _data["time"];
            this.phone = _data["phone"];
            this.hasLogo = _data["hasLogo"];
            this.logoUrl = _data["logoUrl"];
            this.address = _data["address"];
            this.tags = _data["tags"];
            this.reimbursementValue = _data["reimbursementValue"];
            this.reimbursementMaxAmount = _data["reimbursementMaxAmount"];
            this.reimbursementMaxPoints = _data["reimbursementMaxPoints"];
            this.salaryAmount = _data["salaryAmount"];
            this.salaryPoints = _data["salaryPoints"];
            this.requiredPurchase = _data["requiredPurchase"];
            this.requiredPurchaseText = _data["requiredPurchaseText"];
            this.requiredPurchaseExclusionText = _data["requiredPurchaseExclusionText"];
            if (Array.isArray(_data["supportedCultureCodes"])) {
                this.supportedCultureCodes = [] as any;
                for (let item of _data["supportedCultureCodes"])
                    this.supportedCultureCodes!.push(item);
            }
            this.storeLocatorLink = _data["storeLocatorLink"];
            this.missionType = _data["missionType"];
            this.isFlashMission = _data["isFlashMission"];
            this.geoLocation = _data["geoLocation"] ? GeoLocation.fromJS(_data["geoLocation"]) : undefined as any;
            this.branchAirportInfo = _data["branchAirportInfo"] ? MissionBranchAirportInfoDto.fromJS(_data["branchAirportInfo"]) : undefined as any;
            this.selectedRelatedMinor = _data["selectedRelatedMinor"] ? EligibleRelatedMinorDto.fromJS(_data["selectedRelatedMinor"]) : undefined as any;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(MissionDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMissionReferralMissionDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionReferralMissionDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioUpdateNotice"] = this.scenarioUpdateNotice ? this.scenarioUpdateNotice.toJSON() : undefined as any;
        data["promotionDisplay"] = this.promotionDisplay ? this.promotionDisplay.toJSON() : undefined as any;
        data["periodStartDate"] = this.periodStartDate ? this.periodStartDate.toISOString() : undefined as any;
        data["periodEndDate"] = this.periodEndDate ? this.periodEndDate.toISOString() : undefined as any;
        data["name"] = this.name;
        data["missionConfigurationName"] = this.missionConfigurationName;
        data["time"] = this.time;
        data["phone"] = this.phone;
        data["hasLogo"] = this.hasLogo;
        data["logoUrl"] = this.logoUrl;
        data["address"] = this.address;
        data["tags"] = this.tags;
        data["reimbursementValue"] = this.reimbursementValue;
        data["reimbursementMaxAmount"] = this.reimbursementMaxAmount;
        data["reimbursementMaxPoints"] = this.reimbursementMaxPoints;
        data["salaryAmount"] = this.salaryAmount;
        data["salaryPoints"] = this.salaryPoints;
        data["requiredPurchase"] = this.requiredPurchase;
        data["requiredPurchaseText"] = this.requiredPurchaseText;
        data["requiredPurchaseExclusionText"] = this.requiredPurchaseExclusionText;
        if (Array.isArray(this.supportedCultureCodes)) {
            data["supportedCultureCodes"] = [];
            for (let item of this.supportedCultureCodes)
                data["supportedCultureCodes"].push(item);
        }
        data["storeLocatorLink"] = this.storeLocatorLink;
        data["missionType"] = this.missionType;
        data["isFlashMission"] = this.isFlashMission;
        data["geoLocation"] = this.geoLocation ? this.geoLocation.toJSON() : undefined as any;
        data["branchAirportInfo"] = this.branchAirportInfo ? this.branchAirportInfo.toJSON() : undefined as any;
        data["selectedRelatedMinor"] = this.selectedRelatedMinor ? this.selectedRelatedMinor.toJSON() : undefined as any;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class GetMissionReferralResponse {
    promotionDisplay?: MissionPromotionDisplayDto | undefined;
    missionReferralId?: string;
    missionReferralToken?: string;
    missionAssignationId?: string;
    periodMissionConfigurationId?: string;
    branchId?: string;
    status?: MissionReferralStatus;
    isAccepted?: boolean;
    senderMysteryShopperName?: string | undefined;
    expiresAt?: Date;
    isExpired?: boolean;
    canAccept?: boolean;
    hasInvitedEmail?: boolean;

    init(_data?: any) {
        if (_data) {
            this.promotionDisplay = _data["promotionDisplay"] ? MissionPromotionDisplayDto.fromJS(_data["promotionDisplay"]) : undefined as any;
            this.missionReferralId = _data["missionReferralId"];
            this.missionReferralToken = _data["missionReferralToken"];
            this.missionAssignationId = _data["missionAssignationId"];
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            this.branchId = _data["branchId"];
            this.status = _data["status"];
            this.isAccepted = _data["isAccepted"];
            this.senderMysteryShopperName = _data["senderMysteryShopperName"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : undefined as any;
            this.isExpired = _data["isExpired"];
            this.canAccept = _data["canAccept"];
            this.hasInvitedEmail = _data["hasInvitedEmail"];
        }
    }

    static fromJS(data: any): GetMissionReferralResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionReferralResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promotionDisplay"] = this.promotionDisplay ? this.promotionDisplay.toJSON() : undefined as any;
        data["missionReferralId"] = this.missionReferralId;
        data["missionReferralToken"] = this.missionReferralToken;
        data["missionAssignationId"] = this.missionAssignationId;
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        data["branchId"] = this.branchId;
        data["status"] = this.status;
        data["isAccepted"] = this.isAccepted;
        data["senderMysteryShopperName"] = this.senderMysteryShopperName;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : undefined as any;
        data["isExpired"] = this.isExpired;
        data["canAccept"] = this.canAccept;
        data["hasInvitedEmail"] = this.hasInvitedEmail;
        return data;
    }
}

export class GetMissionReferralAcceptabilityResponse {
    canAccept?: boolean;
    missionReferralId?: string;
    missionAssignationId?: string | undefined;
    periodMissionConfigurationId?: string;
    branchId?: string;
    acceptMissionStatus?: AcceptMissionStatus;
    verifyUserPhoneNumber?: boolean;
    hardLimitReached?: boolean;
    ageRestrictionType?: AgeRestrictionType | undefined;
    requiresRelatedMinorSelection?: boolean;
    eligibleRelatedMinors?: EligibleRelatedMinorDto[];
    missingProfileMembers?: GetMysteryShopperProfileMemberDto[] | undefined;
    rotationInfo?: AcceptMissionRotationInfoDto | undefined;

    init(_data?: any) {
        if (_data) {
            this.canAccept = _data["canAccept"];
            this.missionReferralId = _data["missionReferralId"];
            this.missionAssignationId = _data["missionAssignationId"];
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            this.branchId = _data["branchId"];
            this.acceptMissionStatus = _data["acceptMissionStatus"];
            this.verifyUserPhoneNumber = _data["verifyUserPhoneNumber"];
            this.hardLimitReached = _data["hardLimitReached"];
            this.ageRestrictionType = _data["ageRestrictionType"];
            this.requiresRelatedMinorSelection = _data["requiresRelatedMinorSelection"];
            if (Array.isArray(_data["eligibleRelatedMinors"])) {
                this.eligibleRelatedMinors = [] as any;
                for (let item of _data["eligibleRelatedMinors"])
                    this.eligibleRelatedMinors!.push(EligibleRelatedMinorDto.fromJS(item));
            }
            if (Array.isArray(_data["missingProfileMembers"])) {
                this.missingProfileMembers = [] as any;
                for (let item of _data["missingProfileMembers"])
                    this.missingProfileMembers!.push(GetMysteryShopperProfileMemberDto.fromJS(item));
            }
            this.rotationInfo = _data["rotationInfo"] ? AcceptMissionRotationInfoDto.fromJS(_data["rotationInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetMissionReferralAcceptabilityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionReferralAcceptabilityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canAccept"] = this.canAccept;
        data["missionReferralId"] = this.missionReferralId;
        data["missionAssignationId"] = this.missionAssignationId;
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        data["branchId"] = this.branchId;
        data["acceptMissionStatus"] = this.acceptMissionStatus;
        data["verifyUserPhoneNumber"] = this.verifyUserPhoneNumber;
        data["hardLimitReached"] = this.hardLimitReached;
        data["ageRestrictionType"] = this.ageRestrictionType;
        data["requiresRelatedMinorSelection"] = this.requiresRelatedMinorSelection;
        if (Array.isArray(this.eligibleRelatedMinors)) {
            data["eligibleRelatedMinors"] = [];
            for (let item of this.eligibleRelatedMinors)
                data["eligibleRelatedMinors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.missingProfileMembers)) {
            data["missingProfileMembers"] = [];
            for (let item of this.missingProfileMembers)
                data["missingProfileMembers"].push(item ? item.toJSON() : undefined as any);
        }
        data["rotationInfo"] = this.rotationInfo ? this.rotationInfo.toJSON() : undefined as any;
        return data;
    }
}

export class AcceptMissionReferralResponse {
    scenarioUpdateNotice?: ScenarioUpdateNoticeDto | undefined;
    success?: boolean;
    status?: AcceptMissionReferralStatus;
    missionReferralId?: string | undefined;
    missionAssignationId?: string | undefined;
    missionEndDate?: Date | undefined;
    acceptMissionStatus?: AcceptMissionStatus;
    verifyUserPhoneNumber?: boolean;
    hardLimitReached?: boolean;
    requiresRelatedMinor?: boolean;
    eligibleRelatedMinors?: EligibleRelatedMinorDto[];
    missingProfileMembers?: GetMysteryShopperProfileMemberDto[] | undefined;
    rotationInfo?: AcceptMissionRotationInfoDto | undefined;
    geolocationRequirement?: GeolocationRequirement;
    geolocationRadiusMeters?: number | undefined;

    init(_data?: any) {
        if (_data) {
            this.scenarioUpdateNotice = _data["scenarioUpdateNotice"] ? ScenarioUpdateNoticeDto.fromJS(_data["scenarioUpdateNotice"]) : undefined as any;
            this.success = _data["success"];
            this.status = _data["status"];
            this.missionReferralId = _data["missionReferralId"];
            this.missionAssignationId = _data["missionAssignationId"];
            this.missionEndDate = _data["missionEndDate"] ? new Date(_data["missionEndDate"].toString()) : undefined as any;
            this.acceptMissionStatus = _data["acceptMissionStatus"];
            this.verifyUserPhoneNumber = _data["verifyUserPhoneNumber"];
            this.hardLimitReached = _data["hardLimitReached"];
            this.requiresRelatedMinor = _data["requiresRelatedMinor"];
            if (Array.isArray(_data["eligibleRelatedMinors"])) {
                this.eligibleRelatedMinors = [] as any;
                for (let item of _data["eligibleRelatedMinors"])
                    this.eligibleRelatedMinors!.push(EligibleRelatedMinorDto.fromJS(item));
            }
            if (Array.isArray(_data["missingProfileMembers"])) {
                this.missingProfileMembers = [] as any;
                for (let item of _data["missingProfileMembers"])
                    this.missingProfileMembers!.push(GetMysteryShopperProfileMemberDto.fromJS(item));
            }
            this.rotationInfo = _data["rotationInfo"] ? AcceptMissionRotationInfoDto.fromJS(_data["rotationInfo"]) : undefined as any;
            this.geolocationRequirement = _data["geolocationRequirement"];
            this.geolocationRadiusMeters = _data["geolocationRadiusMeters"];
        }
    }

    static fromJS(data: any): AcceptMissionReferralResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptMissionReferralResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioUpdateNotice"] = this.scenarioUpdateNotice ? this.scenarioUpdateNotice.toJSON() : undefined as any;
        data["success"] = this.success;
        data["status"] = this.status;
        data["missionReferralId"] = this.missionReferralId;
        data["missionAssignationId"] = this.missionAssignationId;
        data["missionEndDate"] = this.missionEndDate ? this.missionEndDate.toISOString() : undefined as any;
        data["acceptMissionStatus"] = this.acceptMissionStatus;
        data["verifyUserPhoneNumber"] = this.verifyUserPhoneNumber;
        data["hardLimitReached"] = this.hardLimitReached;
        data["requiresRelatedMinor"] = this.requiresRelatedMinor;
        if (Array.isArray(this.eligibleRelatedMinors)) {
            data["eligibleRelatedMinors"] = [];
            for (let item of this.eligibleRelatedMinors)
                data["eligibleRelatedMinors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.missingProfileMembers)) {
            data["missingProfileMembers"] = [];
            for (let item of this.missingProfileMembers)
                data["missingProfileMembers"].push(item ? item.toJSON() : undefined as any);
        }
        data["rotationInfo"] = this.rotationInfo ? this.rotationInfo.toJSON() : undefined as any;
        data["geolocationRequirement"] = this.geolocationRequirement;
        data["geolocationRadiusMeters"] = this.geolocationRadiusMeters;
        return data;
    }
}

export enum AcceptMissionReferralStatus {
    Accepted = 0,
    InvitationAccepted = 1,
    InvitationCanceled = 2,
    Expired = 3,
    RecipientIneligible = 4,
    Retry = 5,
    ScenarioReviewRequired = 6,
}

export class AcceptMissionReferralRequest {
    scenarioReviewCompleted?: boolean;
    startDate?: Date | undefined;
    selectedRelatedMinorId?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.scenarioReviewCompleted = _data["scenarioReviewCompleted"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.selectedRelatedMinorId = _data["selectedRelatedMinorId"];
        }
    }

    static fromJS(data: any): AcceptMissionReferralRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptMissionReferralRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioReviewCompleted"] = this.scenarioReviewCompleted;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["selectedRelatedMinorId"] = this.selectedRelatedMinorId;
        return data;
    }
}

export class CancelMissionReferralResponse {
    success?: boolean;
    missionReferralId?: string;
    missionAssignationId?: string | undefined;
    status?: MissionReferralStatus;
    cancellationReason?: MissionReferralCancellationReason | undefined;

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.missionReferralId = _data["missionReferralId"];
            this.missionAssignationId = _data["missionAssignationId"];
            this.status = _data["status"];
            this.cancellationReason = _data["cancellationReason"];
        }
    }

    static fromJS(data: any): CancelMissionReferralResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CancelMissionReferralResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["missionReferralId"] = this.missionReferralId;
        data["missionAssignationId"] = this.missionAssignationId;
        data["status"] = this.status;
        data["cancellationReason"] = this.cancellationReason;
        return data;
    }
}

export enum MissionReferralCancellationReason {
    SenderCanceled = 0,
    AdminCanceled = 1,
    Expired = 2,
    RecipientIneligible = 3,
    MissionUnavailable = 4,
    AcceptanceConflict = 5,
}

export class SendMissionReferralEmailResponse {
    success?: boolean;
    status?: SendMissionReferralEmailStatus;
    missionReferralId?: string;
    missionAssignationId?: string | undefined;
    referralUrl?: string | undefined;
    expiresAt?: Date;
    emailSent?: boolean;
    emailMessageId?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
            this.missionReferralId = _data["missionReferralId"];
            this.missionAssignationId = _data["missionAssignationId"];
            this.referralUrl = _data["referralUrl"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : undefined as any;
            this.emailSent = _data["emailSent"];
            this.emailMessageId = _data["emailMessageId"];
        }
    }

    static fromJS(data: any): SendMissionReferralEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendMissionReferralEmailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        data["missionReferralId"] = this.missionReferralId;
        data["missionAssignationId"] = this.missionAssignationId;
        data["referralUrl"] = this.referralUrl;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : undefined as any;
        data["emailSent"] = this.emailSent;
        data["emailMessageId"] = this.emailMessageId;
        return data;
    }
}

export enum SendMissionReferralEmailStatus {
    EmailSent = 0,
    EmailDeliveryFailed = 1,
    InvitationAccepted = 2,
    InvitationCanceled = 3,
    Expired = 4,
    Retry = 5,
    ReminderSent = 6,
    ReminderDeliveryFailed = 7,
    MissionNotActive = 8,
}

export class SendMissionReferralEmailRequest {
    invitedEmail?: string;

    init(_data?: any) {
        if (_data) {
            this.invitedEmail = _data["invitedEmail"];
        }
    }

    static fromJS(data: any): SendMissionReferralEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendMissionReferralEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitedEmail"] = this.invitedEmail;
        return data;
    }
}

export class MissionGeolocationCheckInResult {
    status?: MissionGeolocationCheckInStatus;
    allowedRadiusMeters?: number;
    distanceMeters?: number | undefined;
    maximumAccuracyMeters?: number;
    checkedInAtUtc?: Date | undefined;

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.allowedRadiusMeters = _data["allowedRadiusMeters"];
            this.distanceMeters = _data["distanceMeters"];
            this.maximumAccuracyMeters = _data["maximumAccuracyMeters"];
            this.checkedInAtUtc = _data["checkedInAtUtc"] ? new Date(_data["checkedInAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): MissionGeolocationCheckInResult {
        data = typeof data === 'object' ? data : {};
        let result = new MissionGeolocationCheckInResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["allowedRadiusMeters"] = this.allowedRadiusMeters;
        data["distanceMeters"] = this.distanceMeters;
        data["maximumAccuracyMeters"] = this.maximumAccuracyMeters;
        data["checkedInAtUtc"] = this.checkedInAtUtc ? this.checkedInAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export enum MissionGeolocationCheckInStatus {
    Success = 0,
    AlreadyCheckedIn = 1,
    OutsideRadius = 2,
    InsufficientAccuracy = 3,
    MissingBranchCoordinates = 4,
    MissionUnavailable = 5,
    InvalidLocation = 6,
    NotApplicable = 7,
}

export class MissionGeolocationCheckInRequest {
    latitude?: number;
    longitude?: number;
    accuracyMeters?: number;

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.accuracyMeters = _data["accuracyMeters"];
        }
    }

    static fromJS(data: any): MissionGeolocationCheckInRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MissionGeolocationCheckInRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["accuracyMeters"] = this.accuracyMeters;
        return data;
    }
}

export class SaveMissionAnswerDto {
    missionAssignationId?: string | undefined;
    answerJson?: string;
    periodMissionConfigurationId?: string;
    rootMissionAssignationId?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.missionAssignationId = _data["missionAssignationId"];
            this.answerJson = _data["answerJson"];
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            this.rootMissionAssignationId = _data["rootMissionAssignationId"];
        }
    }

    static fromJS(data: any): SaveMissionAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMissionAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionAssignationId"] = this.missionAssignationId;
        data["answerJson"] = this.answerJson;
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        data["rootMissionAssignationId"] = this.rootMissionAssignationId;
        return data;
    }
}

export class PartialSaveMissionAnswerRequest {
    answer?: SaveMissionAnswerDto;
    formVersionId?: string;
    metadataJson?: string | undefined;
    progress?: MissionAnswerProgressRequest | undefined;

    init(_data?: any) {
        if (_data) {
            this.answer = _data["answer"] ? SaveMissionAnswerDto.fromJS(_data["answer"]) : undefined as any;
            this.formVersionId = _data["formVersionId"];
            this.metadataJson = _data["metadataJson"];
            this.progress = _data["progress"] ? MissionAnswerProgressRequest.fromJS(_data["progress"]) : undefined as any;
        }
    }

    static fromJS(data: any): PartialSaveMissionAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PartialSaveMissionAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answer"] = this.answer ? this.answer.toJSON() : undefined as any;
        data["formVersionId"] = this.formVersionId;
        data["metadataJson"] = this.metadataJson;
        data["progress"] = this.progress ? this.progress.toJSON() : undefined as any;
        return data;
    }
}

export class MissionAnswerProgressRequest {
    trackingVersion?: number;
    currentPageIndex?: number;
    visiblePageCount?: number;
    answeredQuestionCount?: number;
    visibleQuestionCount?: number;
    lastChangedQuestionName?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.trackingVersion = _data["trackingVersion"];
            this.currentPageIndex = _data["currentPageIndex"];
            this.visiblePageCount = _data["visiblePageCount"];
            this.answeredQuestionCount = _data["answeredQuestionCount"];
            this.visibleQuestionCount = _data["visibleQuestionCount"];
            this.lastChangedQuestionName = _data["lastChangedQuestionName"];
        }
    }

    static fromJS(data: any): MissionAnswerProgressRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MissionAnswerProgressRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackingVersion"] = this.trackingVersion;
        data["currentPageIndex"] = this.currentPageIndex;
        data["visiblePageCount"] = this.visiblePageCount;
        data["answeredQuestionCount"] = this.answeredQuestionCount;
        data["visibleQuestionCount"] = this.visibleQuestionCount;
        data["lastChangedQuestionName"] = this.lastChangedQuestionName;
        return data;
    }
}

export class GetSurveyFromMissionAssignationViewModel {
    survey?: SurveyFormModel;
    subscriptionInfo?: GetSurveyFromMissionAssignationSubscriptionInformationDto;
    branchInfo?: GetSurveyFromMissionAssignationBranchInformationDto | undefined;
    restrictedLanguage?: string | undefined;
    surveyRuntime?: string;
    surveyRuntimeRevision?: number;
    competitorCircuitId?: string | undefined;
    competitorCircuitMainMissionAssignationId?: string | undefined;
    competitorCircuitRole?: CompetitorCircuitRole;

    init(_data?: any) {
        if (_data) {
            this.survey = _data["survey"] ? SurveyFormModel.fromJS(_data["survey"]) : undefined as any;
            this.subscriptionInfo = _data["subscriptionInfo"] ? GetSurveyFromMissionAssignationSubscriptionInformationDto.fromJS(_data["subscriptionInfo"]) : undefined as any;
            this.branchInfo = _data["branchInfo"] ? GetSurveyFromMissionAssignationBranchInformationDto.fromJS(_data["branchInfo"]) : undefined as any;
            this.restrictedLanguage = _data["restrictedLanguage"];
            this.surveyRuntime = _data["surveyRuntime"];
            this.surveyRuntimeRevision = _data["surveyRuntimeRevision"];
            this.competitorCircuitId = _data["competitorCircuitId"];
            this.competitorCircuitMainMissionAssignationId = _data["competitorCircuitMainMissionAssignationId"];
            this.competitorCircuitRole = _data["competitorCircuitRole"];
        }
    }

    static fromJS(data: any): GetSurveyFromMissionAssignationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyFromMissionAssignationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["survey"] = this.survey ? this.survey.toJSON() : undefined as any;
        data["subscriptionInfo"] = this.subscriptionInfo ? this.subscriptionInfo.toJSON() : undefined as any;
        data["branchInfo"] = this.branchInfo ? this.branchInfo.toJSON() : undefined as any;
        data["restrictedLanguage"] = this.restrictedLanguage;
        data["surveyRuntime"] = this.surveyRuntime;
        data["surveyRuntimeRevision"] = this.surveyRuntimeRevision;
        data["competitorCircuitId"] = this.competitorCircuitId;
        data["competitorCircuitMainMissionAssignationId"] = this.competitorCircuitMainMissionAssignationId;
        data["competitorCircuitRole"] = this.competitorCircuitRole;
        return data;
    }
}

export class SurveyFormModel {
    missionAssignationId?: string | undefined;
    formJson?: string;
    formAnswerJson?: string | undefined;
    metadataJson?: string | undefined;
    periodMissionConfigurationId?: string;
    formVersionId?: string;
    nextForm?: SurveyFormModel | undefined;

    init(_data?: any) {
        if (_data) {
            this.missionAssignationId = _data["missionAssignationId"];
            this.formJson = _data["formJson"];
            this.formAnswerJson = _data["formAnswerJson"];
            this.metadataJson = _data["metadataJson"];
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            this.formVersionId = _data["formVersionId"];
            this.nextForm = _data["nextForm"] ? SurveyFormModel.fromJS(_data["nextForm"]) : undefined as any;
        }
    }

    static fromJS(data: any): SurveyFormModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyFormModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionAssignationId"] = this.missionAssignationId;
        data["formJson"] = this.formJson;
        data["formAnswerJson"] = this.formAnswerJson;
        data["metadataJson"] = this.metadataJson;
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        data["formVersionId"] = this.formVersionId;
        data["nextForm"] = this.nextForm ? this.nextForm.toJSON() : undefined as any;
        return data;
    }
}

export class GetSurveyFromMissionAssignationSubscriptionInformationDto {
    id?: string;
    name?: string;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetSurveyFromMissionAssignationSubscriptionInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyFromMissionAssignationSubscriptionInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export class GetSurveyFromMissionAssignationBranchInformationDto {
    id?: string;
    name?: string;
    code?: string;
    address?: string;
    logoUrl?: string;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.address = _data["address"];
            this.logoUrl = _data["logoUrl"];
        }
    }

    static fromJS(data: any): GetSurveyFromMissionAssignationBranchInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyFromMissionAssignationBranchInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["address"] = this.address;
        data["logoUrl"] = this.logoUrl;
        return data;
    }
}

export enum CompetitorCircuitRole {
    None = 0,
    Main = 1,
    Competitor = 2,
    FollowUp = 3,
}

export class ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export class GetMyMissionExtendibleDaysViewModel {
    days?: number[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(item);
            }
        }
    }

    static fromJS(data: any): GetMyMissionExtendibleDaysViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyMissionExtendibleDaysViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item);
        }
        return data;
    }
}

export class GetMyMissionListViewModel {
    missions?: GetMyMissionsListStatusDto[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["missions"])) {
                this.missions = [] as any;
                for (let item of _data["missions"])
                    this.missions!.push(GetMyMissionsListStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMyMissionListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyMissionListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.missions)) {
            data["missions"] = [];
            for (let item of this.missions)
                data["missions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class GetMyMissionsListStatusDto {
    status?: MissionAssignationStatus;
    missionsList?: GetMyMissionListDto[];

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["missionsList"])) {
                this.missionsList = [] as any;
                for (let item of _data["missionsList"])
                    this.missionsList!.push(GetMyMissionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMyMissionsListStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyMissionsListStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.missionsList)) {
            data["missionsList"] = [];
            for (let item of this.missionsList)
                data["missionsList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class GetMyMissionListDto {
    promotionDisplay?: MissionPromotionDisplayDto | undefined;
    id?: string;
    branchId?: string | undefined;
    name?: string;
    phone?: string | undefined;
    hasLogo?: boolean;
    logoUrl?: string | undefined;
    address?: string | undefined;
    missionConfigurationName?: string;
    geoLocation?: GeoLocation | undefined;
    missionType?: MissionType;
    remoteActivity?: RemoteMissionActivity | undefined;
    requiresPhoneCall?: boolean;
    requiresEmail?: boolean;
    locationType?: LocationSettingsType;
    isAssociatedWithBranch?: boolean;
    isFlashMission?: boolean;
    isReferral?: boolean;
    competitorCircuitId?: string | undefined;
    isCompetitorCircuit?: boolean;
    competitorCircuitCompletedSteps?: number;
    competitorCircuitTotalSteps?: number;

    init(_data?: any) {
        if (_data) {
            this.promotionDisplay = _data["promotionDisplay"] ? MissionPromotionDisplayDto.fromJS(_data["promotionDisplay"]) : undefined as any;
            this.id = _data["id"];
            this.branchId = _data["branchId"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.hasLogo = _data["hasLogo"];
            this.logoUrl = _data["logoUrl"];
            this.address = _data["address"];
            this.missionConfigurationName = _data["missionConfigurationName"];
            this.geoLocation = _data["geoLocation"] ? GeoLocation.fromJS(_data["geoLocation"]) : undefined as any;
            this.missionType = _data["missionType"];
            this.remoteActivity = _data["remoteActivity"];
            this.requiresPhoneCall = _data["requiresPhoneCall"];
            this.requiresEmail = _data["requiresEmail"];
            this.locationType = _data["locationType"];
            this.isAssociatedWithBranch = _data["isAssociatedWithBranch"];
            this.isFlashMission = _data["isFlashMission"];
            this.isReferral = _data["isReferral"];
            this.competitorCircuitId = _data["competitorCircuitId"];
            this.isCompetitorCircuit = _data["isCompetitorCircuit"];
            this.competitorCircuitCompletedSteps = _data["competitorCircuitCompletedSteps"];
            this.competitorCircuitTotalSteps = _data["competitorCircuitTotalSteps"];
        }
    }

    static fromJS(data: any): GetMyMissionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyMissionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promotionDisplay"] = this.promotionDisplay ? this.promotionDisplay.toJSON() : undefined as any;
        data["id"] = this.id;
        data["branchId"] = this.branchId;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["hasLogo"] = this.hasLogo;
        data["logoUrl"] = this.logoUrl;
        data["address"] = this.address;
        data["missionConfigurationName"] = this.missionConfigurationName;
        data["geoLocation"] = this.geoLocation ? this.geoLocation.toJSON() : undefined as any;
        data["missionType"] = this.missionType;
        data["remoteActivity"] = this.remoteActivity;
        data["requiresPhoneCall"] = this.requiresPhoneCall;
        data["requiresEmail"] = this.requiresEmail;
        data["locationType"] = this.locationType;
        data["isAssociatedWithBranch"] = this.isAssociatedWithBranch;
        data["isFlashMission"] = this.isFlashMission;
        data["isReferral"] = this.isReferral;
        data["competitorCircuitId"] = this.competitorCircuitId;
        data["isCompetitorCircuit"] = this.isCompetitorCircuit;
        data["competitorCircuitCompletedSteps"] = this.competitorCircuitCompletedSteps;
        data["competitorCircuitTotalSteps"] = this.competitorCircuitTotalSteps;
        return data;
    }
}

export class CompetitorCircuitDetailsResponse {
    id?: string;
    status?: CompetitorCircuitStatus;
    completedSteps?: number;
    totalSteps?: number;
    isPaid?: boolean;
    steps?: CompetitorCircuitStepResponse[];

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.completedSteps = _data["completedSteps"];
            this.totalSteps = _data["totalSteps"];
            this.isPaid = _data["isPaid"];
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(CompetitorCircuitStepResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompetitorCircuitDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitorCircuitDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["completedSteps"] = this.completedSteps;
        data["totalSteps"] = this.totalSteps;
        data["isPaid"] = this.isPaid;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export enum CompetitorCircuitStatus {
    Active = 0,
    AwaitingFollowUp = 1,
    AwaitingApproval = 2,
    FraudReview = 3,
    Completed = 4,
    Cancelled = 5,
}

export class CompetitorCircuitStepResponse {
    missionAssignationId?: string;
    role?: CompetitorCircuitRole;
    name?: string;
    address?: string;
    status?: MissionAssignationStatus;
    submittedDateUtc?: Date | undefined;
    approvedDateUtc?: Date | undefined;
    hasUnresolvedFraud?: boolean;

    init(_data?: any) {
        if (_data) {
            this.missionAssignationId = _data["missionAssignationId"];
            this.role = _data["role"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.status = _data["status"];
            this.submittedDateUtc = _data["submittedDateUtc"] ? new Date(_data["submittedDateUtc"].toString()) : undefined as any;
            this.approvedDateUtc = _data["approvedDateUtc"] ? new Date(_data["approvedDateUtc"].toString()) : undefined as any;
            this.hasUnresolvedFraud = _data["hasUnresolvedFraud"];
        }
    }

    static fromJS(data: any): CompetitorCircuitStepResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitorCircuitStepResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionAssignationId"] = this.missionAssignationId;
        data["role"] = this.role;
        data["name"] = this.name;
        data["address"] = this.address;
        data["status"] = this.status;
        data["submittedDateUtc"] = this.submittedDateUtc ? this.submittedDateUtc.toISOString() : undefined as any;
        data["approvedDateUtc"] = this.approvedDateUtc ? this.approvedDateUtc.toISOString() : undefined as any;
        data["hasUnresolvedFraud"] = this.hasUnresolvedFraud;
        return data;
    }
}

export class GetAirportTakenCountViewModel {
    takenCount?: number;
    reachedLimit?: boolean;
    limit?: number;

    init(_data?: any) {
        if (_data) {
            this.takenCount = _data["takenCount"];
            this.reachedLimit = _data["reachedLimit"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): GetAirportTakenCountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAirportTakenCountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["takenCount"] = this.takenCount;
        data["reachedLimit"] = this.reachedLimit;
        data["limit"] = this.limit;
        return data;
    }
}

export class GetMyMissionDetailsViewModel {
    missionDetails?: GetMyMissionDetailsDto;

    init(_data?: any) {
        if (_data) {
            this.missionDetails = _data["missionDetails"] ? GetMyMissionDetailsDto.fromJS(_data["missionDetails"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetMyMissionDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyMissionDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionDetails"] = this.missionDetails ? this.missionDetails.toJSON() : undefined as any;
        return data;
    }
}

export class GetMyMissionDetailsDto {
    scenarioUpdateNotice?: ScenarioUpdateNoticeDto | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    website?: string | undefined;
    promotionDisplay?: MissionPromotionDisplayDto | undefined;
    missionType?: MissionType;
    remoteActivity?: RemoteMissionActivity | undefined;
    requiresPhoneCall?: boolean;
    requiresEmail?: boolean;
    locationType?: LocationSettingsType;
    totalPaymentMaxAmount?: number | undefined;
    isReferral?: boolean;
    createdDate?: Date;
    dateOfVisit?: Date | undefined;
    submittedDate?: Date | undefined;
    validatedDate?: Date | undefined;
    isCancellable?: boolean;
    canAnswerSurvey?: boolean;
    geolocationRequirement?: GeolocationRequirement;
    geolocationRadiusMeters?: number | undefined;
    hasGeolocationCheckIn?: boolean;
    geolocationCheckIn?: MissionGeolocationCheckInSummaryDto | undefined;
    periodStartDate?: Date | undefined;
    status?: MissionAssignationStatus;
    prevalidationSteps?: PrevalidationSteps;
    inProgress?: boolean;
    svgIcon?: string | undefined;
    time?: string | undefined;
    tagCount?: number;
    tags?: string | undefined;
    reimbursementValue?: string | undefined;
    reimbursementMaxAmount?: number | undefined;
    reimbursementMaxPoints?: number | undefined;
    salaryAmount?: number | undefined;
    salaryPoints?: number | undefined;
    totalAmount?: number | undefined;
    requiredPurchase?: boolean;
    requiredPurchaseText?: string | undefined;
    requiredPurchaseExclusionText?: string | undefined;
    locationValue?: string | undefined;
    supportedCultureCodes?: string[] | undefined;
    isExtendable?: boolean;
    maxExtendableDays?: number | undefined;
    daysLeft?: number | undefined;
    endDate?: Date | undefined;
    selectedRelatedMinor?: EligibleRelatedMinorDto | undefined;
    contactPerson?: ContactPersonDto | undefined;
    competitorCircuitId?: string | undefined;
    competitorCircuitRole?: CompetitorCircuitRole;
    branchAirportInfo?: MissionBranchAirportInfoDto | undefined;
    missionDetails?: MissionDetailsDto[];
    missionConfigurationName?: string;

    init(_data?: any) {
        if (_data) {
            this.scenarioUpdateNotice = _data["scenarioUpdateNotice"] ? ScenarioUpdateNoticeDto.fromJS(_data["scenarioUpdateNotice"]) : undefined as any;
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.promotionDisplay = _data["promotionDisplay"] ? MissionPromotionDisplayDto.fromJS(_data["promotionDisplay"]) : undefined as any;
            this.missionType = _data["missionType"];
            this.remoteActivity = _data["remoteActivity"];
            this.requiresPhoneCall = _data["requiresPhoneCall"];
            this.requiresEmail = _data["requiresEmail"];
            this.locationType = _data["locationType"];
            this.totalPaymentMaxAmount = _data["totalPaymentMaxAmount"];
            this.isReferral = _data["isReferral"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.dateOfVisit = _data["dateOfVisit"] ? new Date(_data["dateOfVisit"].toString()) : undefined as any;
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : undefined as any;
            this.validatedDate = _data["validatedDate"] ? new Date(_data["validatedDate"].toString()) : undefined as any;
            this.isCancellable = _data["isCancellable"];
            this.canAnswerSurvey = _data["canAnswerSurvey"];
            this.geolocationRequirement = _data["geolocationRequirement"];
            this.geolocationRadiusMeters = _data["geolocationRadiusMeters"];
            this.hasGeolocationCheckIn = _data["hasGeolocationCheckIn"];
            this.geolocationCheckIn = _data["geolocationCheckIn"] ? MissionGeolocationCheckInSummaryDto.fromJS(_data["geolocationCheckIn"]) : undefined as any;
            this.periodStartDate = _data["periodStartDate"] ? new Date(_data["periodStartDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.prevalidationSteps = _data["prevalidationSteps"];
            this.inProgress = _data["inProgress"];
            this.svgIcon = _data["svgIcon"];
            this.time = _data["time"];
            this.tagCount = _data["tagCount"];
            this.tags = _data["tags"];
            this.reimbursementValue = _data["reimbursementValue"];
            this.reimbursementMaxAmount = _data["reimbursementMaxAmount"];
            this.reimbursementMaxPoints = _data["reimbursementMaxPoints"];
            this.salaryAmount = _data["salaryAmount"];
            this.salaryPoints = _data["salaryPoints"];
            this.totalAmount = _data["totalAmount"];
            this.requiredPurchase = _data["requiredPurchase"];
            this.requiredPurchaseText = _data["requiredPurchaseText"];
            this.requiredPurchaseExclusionText = _data["requiredPurchaseExclusionText"];
            this.locationValue = _data["locationValue"];
            if (Array.isArray(_data["supportedCultureCodes"])) {
                this.supportedCultureCodes = [] as any;
                for (let item of _data["supportedCultureCodes"])
                    this.supportedCultureCodes!.push(item);
            }
            this.isExtendable = _data["isExtendable"];
            this.maxExtendableDays = _data["maxExtendableDays"];
            this.daysLeft = _data["daysLeft"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.selectedRelatedMinor = _data["selectedRelatedMinor"] ? EligibleRelatedMinorDto.fromJS(_data["selectedRelatedMinor"]) : undefined as any;
            this.contactPerson = _data["contactPerson"] ? ContactPersonDto.fromJS(_data["contactPerson"]) : undefined as any;
            this.competitorCircuitId = _data["competitorCircuitId"];
            this.competitorCircuitRole = _data["competitorCircuitRole"];
            this.branchAirportInfo = _data["branchAirportInfo"] ? MissionBranchAirportInfoDto.fromJS(_data["branchAirportInfo"]) : undefined as any;
            if (Array.isArray(_data["missionDetails"])) {
                this.missionDetails = [] as any;
                for (let item of _data["missionDetails"])
                    this.missionDetails!.push(MissionDetailsDto.fromJS(item));
            }
            this.missionConfigurationName = _data["missionConfigurationName"];
        }
    }

    static fromJS(data: any): GetMyMissionDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyMissionDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioUpdateNotice"] = this.scenarioUpdateNotice ? this.scenarioUpdateNotice.toJSON() : undefined as any;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["website"] = this.website;
        data["promotionDisplay"] = this.promotionDisplay ? this.promotionDisplay.toJSON() : undefined as any;
        data["missionType"] = this.missionType;
        data["remoteActivity"] = this.remoteActivity;
        data["requiresPhoneCall"] = this.requiresPhoneCall;
        data["requiresEmail"] = this.requiresEmail;
        data["locationType"] = this.locationType;
        data["totalPaymentMaxAmount"] = this.totalPaymentMaxAmount;
        data["isReferral"] = this.isReferral;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["dateOfVisit"] = this.dateOfVisit ? this.dateOfVisit.toISOString() : undefined as any;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : undefined as any;
        data["validatedDate"] = this.validatedDate ? this.validatedDate.toISOString() : undefined as any;
        data["isCancellable"] = this.isCancellable;
        data["canAnswerSurvey"] = this.canAnswerSurvey;
        data["geolocationRequirement"] = this.geolocationRequirement;
        data["geolocationRadiusMeters"] = this.geolocationRadiusMeters;
        data["hasGeolocationCheckIn"] = this.hasGeolocationCheckIn;
        data["geolocationCheckIn"] = this.geolocationCheckIn ? this.geolocationCheckIn.toJSON() : undefined as any;
        data["periodStartDate"] = this.periodStartDate ? this.periodStartDate.toISOString() : undefined as any;
        data["status"] = this.status;
        data["prevalidationSteps"] = this.prevalidationSteps;
        data["inProgress"] = this.inProgress;
        data["svgIcon"] = this.svgIcon;
        data["time"] = this.time;
        data["tagCount"] = this.tagCount;
        data["tags"] = this.tags;
        data["reimbursementValue"] = this.reimbursementValue;
        data["reimbursementMaxAmount"] = this.reimbursementMaxAmount;
        data["reimbursementMaxPoints"] = this.reimbursementMaxPoints;
        data["salaryAmount"] = this.salaryAmount;
        data["salaryPoints"] = this.salaryPoints;
        data["totalAmount"] = this.totalAmount;
        data["requiredPurchase"] = this.requiredPurchase;
        data["requiredPurchaseText"] = this.requiredPurchaseText;
        data["requiredPurchaseExclusionText"] = this.requiredPurchaseExclusionText;
        data["locationValue"] = this.locationValue;
        if (Array.isArray(this.supportedCultureCodes)) {
            data["supportedCultureCodes"] = [];
            for (let item of this.supportedCultureCodes)
                data["supportedCultureCodes"].push(item);
        }
        data["isExtendable"] = this.isExtendable;
        data["maxExtendableDays"] = this.maxExtendableDays;
        data["daysLeft"] = this.daysLeft;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["selectedRelatedMinor"] = this.selectedRelatedMinor ? this.selectedRelatedMinor.toJSON() : undefined as any;
        data["contactPerson"] = this.contactPerson ? this.contactPerson.toJSON() : undefined as any;
        data["competitorCircuitId"] = this.competitorCircuitId;
        data["competitorCircuitRole"] = this.competitorCircuitRole;
        data["branchAirportInfo"] = this.branchAirportInfo ? this.branchAirportInfo.toJSON() : undefined as any;
        if (Array.isArray(this.missionDetails)) {
            data["missionDetails"] = [];
            for (let item of this.missionDetails)
                data["missionDetails"].push(item ? item.toJSON() : undefined as any);
        }
        data["missionConfigurationName"] = this.missionConfigurationName;
        return data;
    }
}

export class MissionGeolocationCheckInSummaryDto {
    checkedInAtUtc?: Date;
    latitude?: number;
    longitude?: number;
    accuracyMeters?: number;
    distanceMeters?: number;
    allowedRadiusMeters?: number;

    init(_data?: any) {
        if (_data) {
            this.checkedInAtUtc = _data["checkedInAtUtc"] ? new Date(_data["checkedInAtUtc"].toString()) : undefined as any;
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.accuracyMeters = _data["accuracyMeters"];
            this.distanceMeters = _data["distanceMeters"];
            this.allowedRadiusMeters = _data["allowedRadiusMeters"];
        }
    }

    static fromJS(data: any): MissionGeolocationCheckInSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissionGeolocationCheckInSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkedInAtUtc"] = this.checkedInAtUtc ? this.checkedInAtUtc.toISOString() : undefined as any;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["accuracyMeters"] = this.accuracyMeters;
        data["distanceMeters"] = this.distanceMeters;
        data["allowedRadiusMeters"] = this.allowedRadiusMeters;
        return data;
    }
}

export enum PrevalidationSteps {
    None = 0,
    Bill = 1,
    DateAndTime = 2,
    FraudDetection = 4,
    WrongPlace = 8,
    IncorrectProduct = 16,
    DifferentMissionTypesSameDay = 32,
}

export class ContactPersonDto {
    name?: string;
    jobTitle?: string;
    phoneNumber?: string;
    callingInstructions?: string;

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.jobTitle = _data["jobTitle"];
            this.phoneNumber = _data["phoneNumber"];
            this.callingInstructions = _data["callingInstructions"];
        }
    }

    static fromJS(data: any): ContactPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["jobTitle"] = this.jobTitle;
        data["phoneNumber"] = this.phoneNumber;
        data["callingInstructions"] = this.callingInstructions;
        return data;
    }
}

export class GetPreValidationResponse {
    preValidation?: PreValidationDto;

    init(_data?: any) {
        if (_data) {
            this.preValidation = _data["preValidation"] ? PreValidationDto.fromJS(_data["preValidation"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetPreValidationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPreValidationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preValidation"] = this.preValidation ? this.preValidation.toJSON() : undefined as any;
        return data;
    }
}

export class PreValidationDto {
    missionType?: MissionType;
    remoteActivity?: RemoteMissionActivity | undefined;
    requiresPhoneCall?: boolean;
    requiresEmail?: boolean;
    locationType?: LocationSettingsType;
    missionAssignationId?: string;
    branchId?: string | undefined;
    name?: string;
    address?: string | undefined;
    time?: string | undefined;
    hasLogo?: boolean;
    logoUrl?: string | undefined;
    branchGeoLocation?: GeoLocation | undefined;
    purchaseRequired?: boolean | undefined;
    purchaseRequiredText?: string | undefined;
    supportedCultureCodes?: string[] | undefined;
    purchaseExclusionText?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.missionType = _data["missionType"];
            this.remoteActivity = _data["remoteActivity"];
            this.requiresPhoneCall = _data["requiresPhoneCall"];
            this.requiresEmail = _data["requiresEmail"];
            this.locationType = _data["locationType"];
            this.missionAssignationId = _data["missionAssignationId"];
            this.branchId = _data["branchId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.time = _data["time"];
            this.hasLogo = _data["hasLogo"];
            this.logoUrl = _data["logoUrl"];
            this.branchGeoLocation = _data["branchGeoLocation"] ? GeoLocation.fromJS(_data["branchGeoLocation"]) : undefined as any;
            this.purchaseRequired = _data["purchaseRequired"];
            this.purchaseRequiredText = _data["purchaseRequiredText"];
            if (Array.isArray(_data["supportedCultureCodes"])) {
                this.supportedCultureCodes = [] as any;
                for (let item of _data["supportedCultureCodes"])
                    this.supportedCultureCodes!.push(item);
            }
            this.purchaseExclusionText = _data["purchaseExclusionText"];
        }
    }

    static fromJS(data: any): PreValidationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreValidationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionType"] = this.missionType;
        data["remoteActivity"] = this.remoteActivity;
        data["requiresPhoneCall"] = this.requiresPhoneCall;
        data["requiresEmail"] = this.requiresEmail;
        data["locationType"] = this.locationType;
        data["missionAssignationId"] = this.missionAssignationId;
        data["branchId"] = this.branchId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["time"] = this.time;
        data["hasLogo"] = this.hasLogo;
        data["logoUrl"] = this.logoUrl;
        data["branchGeoLocation"] = this.branchGeoLocation ? this.branchGeoLocation.toJSON() : undefined as any;
        data["purchaseRequired"] = this.purchaseRequired;
        data["purchaseRequiredText"] = this.purchaseRequiredText;
        if (Array.isArray(this.supportedCultureCodes)) {
            data["supportedCultureCodes"] = [];
            for (let item of this.supportedCultureCodes)
                data["supportedCultureCodes"].push(item);
        }
        data["purchaseExclusionText"] = this.purchaseExclusionText;
        return data;
    }
}

export class GetFailedValidationNotificationViewModel {
    hasFailedValidationMission?: boolean;
    failedValidationMissionAssignationIds?: string[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.hasFailedValidationMission = _data["hasFailedValidationMission"];
            if (Array.isArray(_data["failedValidationMissionAssignationIds"])) {
                this.failedValidationMissionAssignationIds = [] as any;
                for (let item of _data["failedValidationMissionAssignationIds"])
                    this.failedValidationMissionAssignationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetFailedValidationNotificationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetFailedValidationNotificationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasFailedValidationMission"] = this.hasFailedValidationMission;
        if (Array.isArray(this.failedValidationMissionAssignationIds)) {
            data["failedValidationMissionAssignationIds"] = [];
            for (let item of this.failedValidationMissionAssignationIds)
                data["failedValidationMissionAssignationIds"].push(item);
        }
        return data;
    }
}

export class GetMyRewardsViewModel {
    amountPts?: number;
    amountCurrency?: number;
    pointsPerCurrency?: number;
    progression?: GetMyRewardsProgressionDto;

    init(_data?: any) {
        if (_data) {
            this.amountPts = _data["amountPts"];
            this.amountCurrency = _data["amountCurrency"];
            this.pointsPerCurrency = _data["pointsPerCurrency"];
            this.progression = _data["progression"] ? GetMyRewardsProgressionDto.fromJS(_data["progression"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetMyRewardsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyRewardsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountPts"] = this.amountPts;
        data["amountCurrency"] = this.amountCurrency;
        data["pointsPerCurrency"] = this.pointsPerCurrency;
        data["progression"] = this.progression ? this.progression.toJSON() : undefined as any;
        return data;
    }
}

export class GetMyRewardsProgressionDto {
    values?: number[];
    percentageValue?: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            this.percentageValue = _data["percentageValue"];
        }
    }

    static fromJS(data: any): GetMyRewardsProgressionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyRewardsProgressionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        data["percentageValue"] = this.percentageValue;
        return data;
    }
}

export class GetMysteryShopperProfileViewModel {
    profileCompletionBonus?: ProfileCompletionBonusSummaryResponse | undefined;
    activeQualityWarning?: QualityWarningSummaryDto | undefined;
    mysteryShopper?: GetMysteryShopperDto;
    availableProfileMembers?: ProfileMemberDto[];

    init(_data?: any) {
        if (_data) {
            this.profileCompletionBonus = _data["profileCompletionBonus"] ? ProfileCompletionBonusSummaryResponse.fromJS(_data["profileCompletionBonus"]) : undefined as any;
            this.activeQualityWarning = _data["activeQualityWarning"] ? QualityWarningSummaryDto.fromJS(_data["activeQualityWarning"]) : undefined as any;
            this.mysteryShopper = _data["mysteryShopper"] ? GetMysteryShopperDto.fromJS(_data["mysteryShopper"]) : undefined as any;
            if (Array.isArray(_data["availableProfileMembers"])) {
                this.availableProfileMembers = [] as any;
                for (let item of _data["availableProfileMembers"])
                    this.availableProfileMembers!.push(ProfileMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMysteryShopperProfileViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperProfileViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileCompletionBonus"] = this.profileCompletionBonus ? this.profileCompletionBonus.toJSON() : undefined as any;
        data["activeQualityWarning"] = this.activeQualityWarning ? this.activeQualityWarning.toJSON() : undefined as any;
        data["mysteryShopper"] = this.mysteryShopper ? this.mysteryShopper.toJSON() : undefined as any;
        if (Array.isArray(this.availableProfileMembers)) {
            data["availableProfileMembers"] = [];
            for (let item of this.availableProfileMembers)
                data["availableProfileMembers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class ProfileCompletionBonusSummaryResponse {
    campaignState?: ProfileCompletionBonusCampaignState;
    eligible?: boolean;
    completedSections?: number;
    totalSections?: number;
    rewardPoints?: number;
    missingQuestionKeys?: string[];
    pendingAward?: boolean;
    awardedAtUtc?: Date | undefined;

    init(_data?: any) {
        if (_data) {
            this.campaignState = _data["campaignState"];
            this.eligible = _data["eligible"];
            this.completedSections = _data["completedSections"];
            this.totalSections = _data["totalSections"];
            this.rewardPoints = _data["rewardPoints"];
            if (Array.isArray(_data["missingQuestionKeys"])) {
                this.missingQuestionKeys = [] as any;
                for (let item of _data["missingQuestionKeys"])
                    this.missingQuestionKeys!.push(item);
            }
            this.pendingAward = _data["pendingAward"];
            this.awardedAtUtc = _data["awardedAtUtc"] ? new Date(_data["awardedAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ProfileCompletionBonusSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileCompletionBonusSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignState"] = this.campaignState;
        data["eligible"] = this.eligible;
        data["completedSections"] = this.completedSections;
        data["totalSections"] = this.totalSections;
        data["rewardPoints"] = this.rewardPoints;
        if (Array.isArray(this.missingQuestionKeys)) {
            data["missingQuestionKeys"] = [];
            for (let item of this.missingQuestionKeys)
                data["missingQuestionKeys"].push(item);
        }
        data["pendingAward"] = this.pendingAward;
        data["awardedAtUtc"] = this.awardedAtUtc ? this.awardedAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export enum ProfileCompletionBonusCampaignState {
    Disabled = 0,
    Active = 1,
    Paused = 2,
}

export class QualityWarningSummaryDto {
    id?: string;
    messageVersion?: number;
    issuedAtUtc?: Date;
    firstDisplayedAtUtc?: Date | undefined;
    acknowledgedAtUtc?: Date | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.messageVersion = _data["messageVersion"];
            this.issuedAtUtc = _data["issuedAtUtc"] ? new Date(_data["issuedAtUtc"].toString()) : undefined as any;
            this.firstDisplayedAtUtc = _data["firstDisplayedAtUtc"] ? new Date(_data["firstDisplayedAtUtc"].toString()) : undefined as any;
            this.acknowledgedAtUtc = _data["acknowledgedAtUtc"] ? new Date(_data["acknowledgedAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): QualityWarningSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new QualityWarningSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["messageVersion"] = this.messageVersion;
        data["issuedAtUtc"] = this.issuedAtUtc ? this.issuedAtUtc.toISOString() : undefined as any;
        data["firstDisplayedAtUtc"] = this.firstDisplayedAtUtc ? this.firstDisplayedAtUtc.toISOString() : undefined as any;
        data["acknowledgedAtUtc"] = this.acknowledgedAtUtc ? this.acknowledgedAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export class GetMysteryShopperDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string;
    phoneNumber?: string | undefined;
    theme?: DeviceTheme;
    languages?: string[] | undefined;
    verified?: boolean;
    addresses?: GetMysteryShopperAddressDto[];
    profiles?: GetMysteryShopperProfileDto[];

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.theme = _data["theme"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            this.verified = _data["verified"];
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(GetMysteryShopperAddressDto.fromJS(item));
            }
            if (Array.isArray(_data["profiles"])) {
                this.profiles = [] as any;
                for (let item of _data["profiles"])
                    this.profiles!.push(GetMysteryShopperProfileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMysteryShopperDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["theme"] = this.theme;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        data["verified"] = this.verified;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.profiles)) {
            data["profiles"] = [];
            for (let item of this.profiles)
                data["profiles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class GetMysteryShopperAddressDto {
    id?: string;
    type?: MysteryShopperAddressType;
    city?: string;
    postalCode?: string;
    address?: string;
    department?: string;
    country?: string;
    geocoordinate?: GeoLocation;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.address = _data["address"];
            this.department = _data["department"];
            this.country = _data["country"];
            this.geocoordinate = _data["geocoordinate"] ? GeoLocation.fromJS(_data["geocoordinate"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetMysteryShopperAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["address"] = this.address;
        data["department"] = this.department;
        data["country"] = this.country;
        data["geocoordinate"] = this.geocoordinate ? this.geocoordinate.toJSON() : undefined as any;
        return data;
    }
}

export enum MysteryShopperAddressType {
    Home = 0,
    Work = 1,
    School = 2,
    SecondaryHome = 3,
    Other = 4,
    Current = 5,
}

export class GetMysteryShopperProfileDto {
    key?: string;
    value?: string | undefined;
    valueText?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.valueText = _data["valueText"];
        }
    }

    static fromJS(data: any): GetMysteryShopperProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["valueText"] = this.valueText;
        return data;
    }
}

export class ProfileMemberDto {
    key?: string;
    label?: string;
    question?: string;
    enabled?: boolean;
    minValue?: string | undefined;
    maxValue?: string | undefined;
    valueType?: MysteryShopperProfileMemberType;
    comparisons?: EqualityComparisonType[];
    choices?: ProfileMemberChoiceDto[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.question = _data["question"];
            this.enabled = _data["enabled"];
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.valueType = _data["valueType"];
            if (Array.isArray(_data["comparisons"])) {
                this.comparisons = [] as any;
                for (let item of _data["comparisons"])
                    this.comparisons!.push(item);
            }
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(ProfileMemberChoiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfileMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["question"] = this.question;
        data["enabled"] = this.enabled;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["valueType"] = this.valueType;
        if (Array.isArray(this.comparisons)) {
            data["comparisons"] = [];
            for (let item of this.comparisons)
                data["comparisons"].push(item);
        }
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export enum EqualityComparisonType {
    Contains = 0,
    NotContains = 1,
    Equal = 2,
    NotEqual = 3,
    GreaterThanOrEqual = 4,
    GreaterThan = 5,
    LessThan = 6,
    LessThanOrEqual = 7,
    Unknown = -1,
}

export class ProfileMemberChoiceDto {
    key?: number;
    label?: string;
    enabled?: boolean;

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): ProfileMemberChoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileMemberChoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["enabled"] = this.enabled;
        return data;
    }
}

export class MysteryShopperVerificationStatusViewModel {
    adultVerification?: AdultIdVerificationDto;
    relatedMinors?: RelatedMinorDto[];

    init(_data?: any) {
        if (_data) {
            this.adultVerification = _data["adultVerification"] ? AdultIdVerificationDto.fromJS(_data["adultVerification"]) : undefined as any;
            if (Array.isArray(_data["relatedMinors"])) {
                this.relatedMinors = [] as any;
                for (let item of _data["relatedMinors"])
                    this.relatedMinors!.push(RelatedMinorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MysteryShopperVerificationStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MysteryShopperVerificationStatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adultVerification"] = this.adultVerification ? this.adultVerification.toJSON() : undefined as any;
        if (Array.isArray(this.relatedMinors)) {
            data["relatedMinors"] = [];
            for (let item of this.relatedMinors)
                data["relatedMinors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class AdultIdVerificationDto {
    id?: string | undefined;
    status?: MysteryShopperVerificationStatus | undefined;
    canSubmit?: boolean;
    isSoftVerified?: boolean;
    submittedAt?: Date | undefined;
    documentsExpireAt?: Date | undefined;
    documentsDeletedAt?: Date | undefined;
    reviewReason?: string | undefined;
    invalidationReason?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.canSubmit = _data["canSubmit"];
            this.isSoftVerified = _data["isSoftVerified"];
            this.submittedAt = _data["submittedAt"] ? new Date(_data["submittedAt"].toString()) : undefined as any;
            this.documentsExpireAt = _data["documentsExpireAt"] ? new Date(_data["documentsExpireAt"].toString()) : undefined as any;
            this.documentsDeletedAt = _data["documentsDeletedAt"] ? new Date(_data["documentsDeletedAt"].toString()) : undefined as any;
            this.reviewReason = _data["reviewReason"];
            this.invalidationReason = _data["invalidationReason"];
        }
    }

    static fromJS(data: any): AdultIdVerificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdultIdVerificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["canSubmit"] = this.canSubmit;
        data["isSoftVerified"] = this.isSoftVerified;
        data["submittedAt"] = this.submittedAt ? this.submittedAt.toISOString() : undefined as any;
        data["documentsExpireAt"] = this.documentsExpireAt ? this.documentsExpireAt.toISOString() : undefined as any;
        data["documentsDeletedAt"] = this.documentsDeletedAt ? this.documentsDeletedAt.toISOString() : undefined as any;
        data["reviewReason"] = this.reviewReason;
        data["invalidationReason"] = this.invalidationReason;
        return data;
    }
}

export enum MysteryShopperVerificationStatus {
    Pending = 0,
    Approved = 1,
    Rejected = 2,
    Invalidated = 3,
    DocumentsExpired = 4,
}

export class RelatedMinorDto {
    id?: string;
    status?: MysteryShopperVerificationStatus;
    firstName?: string;
    lastName?: string;
    gender?: RelatedMinorGender;
    birthDate?: Date;
    relationship?: RelatedMinorRelationship;
    submittedAt?: Date;
    documentsExpireAt?: Date;
    documentsDeletedAt?: Date | undefined;
    reviewReason?: string | undefined;
    invalidationReason?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gender = _data["gender"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined as any;
            this.relationship = _data["relationship"];
            this.submittedAt = _data["submittedAt"] ? new Date(_data["submittedAt"].toString()) : undefined as any;
            this.documentsExpireAt = _data["documentsExpireAt"] ? new Date(_data["documentsExpireAt"].toString()) : undefined as any;
            this.documentsDeletedAt = _data["documentsDeletedAt"] ? new Date(_data["documentsDeletedAt"].toString()) : undefined as any;
            this.reviewReason = _data["reviewReason"];
            this.invalidationReason = _data["invalidationReason"];
        }
    }

    static fromJS(data: any): RelatedMinorDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelatedMinorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gender"] = this.gender;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined as any;
        data["relationship"] = this.relationship;
        data["submittedAt"] = this.submittedAt ? this.submittedAt.toISOString() : undefined as any;
        data["documentsExpireAt"] = this.documentsExpireAt ? this.documentsExpireAt.toISOString() : undefined as any;
        data["documentsDeletedAt"] = this.documentsDeletedAt ? this.documentsDeletedAt.toISOString() : undefined as any;
        data["reviewReason"] = this.reviewReason;
        data["invalidationReason"] = this.invalidationReason;
        return data;
    }
}

export class PostalAddressDto {
    civicAddress?: string;
    city?: string;
    postalCode?: string;
    department?: string;
    country?: string;

    init(_data?: any) {
        if (_data) {
            this.civicAddress = _data["civicAddress"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.department = _data["department"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): PostalAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostalAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["civicAddress"] = this.civicAddress;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["department"] = this.department;
        data["country"] = this.country;
        return data;
    }
}

export class GeocodeAddressCommandViewModel {
    address?: string;
    postalCode?: string;
    locality?: string;
    province?: string;
    country?: string;

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.locality = _data["locality"];
            this.province = _data["province"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): GeocodeAddressCommandViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GeocodeAddressCommandViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["locality"] = this.locality;
        data["province"] = this.province;
        data["country"] = this.country;
        return data;
    }
}

export class GeocodeAddressCommandDto {
    latitude?: number;
    longitude?: number;

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): GeocodeAddressCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeocodeAddressCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export class SaveProfileValueDto {
    key?: string;
    value?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SaveProfileValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveProfileValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export class SaveBasicInformationDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    languages?: string[] | undefined;
    theme?: DeviceTheme | undefined;

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): SaveBasicInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBasicInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        data["theme"] = this.theme;
        return data;
    }
}

export class MysteryShopperAddressDto {
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    department?: string | undefined;
    country?: string | undefined;
    type?: MysteryShopperAddressType;
    latitude?: number | undefined;
    longitude?: number | undefined;

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.department = _data["department"];
            this.country = _data["country"];
            this.type = _data["type"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): MysteryShopperAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new MysteryShopperAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["department"] = this.department;
        data["country"] = this.country;
        data["type"] = this.type;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export class RegisterDeviceDto {
    deviceType?: MysteryShopperDeviceType;
    operatingSystem?: string;
    version?: string | undefined;
    userAgent?: string | undefined;
    token?: string;

    init(_data?: any) {
        if (_data) {
            this.deviceType = _data["deviceType"];
            this.operatingSystem = _data["operatingSystem"];
            this.version = _data["version"];
            this.userAgent = _data["userAgent"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): RegisterDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceType"] = this.deviceType;
        data["operatingSystem"] = this.operatingSystem;
        data["version"] = this.version;
        data["userAgent"] = this.userAgent;
        data["token"] = this.token;
        return data;
    }
}

export enum MysteryShopperDeviceType {
    Unknown = 0,
    Desktop = 1,
    Mobile = 2,
    Tablet = 3,
}

export class GetAlertBannerViewModel {
    latestRejectedMissionAssignation?: MissionAssignationDto | undefined;
    totalRejectedMissionAssignations?: number;

    init(_data?: any) {
        if (_data) {
            this.latestRejectedMissionAssignation = _data["latestRejectedMissionAssignation"] ? MissionAssignationDto.fromJS(_data["latestRejectedMissionAssignation"]) : undefined as any;
            this.totalRejectedMissionAssignations = _data["totalRejectedMissionAssignations"];
        }
    }

    static fromJS(data: any): GetAlertBannerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlertBannerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latestRejectedMissionAssignation"] = this.latestRejectedMissionAssignation ? this.latestRejectedMissionAssignation.toJSON() : undefined as any;
        data["totalRejectedMissionAssignations"] = this.totalRejectedMissionAssignations;
        return data;
    }
}

export class MissionAssignationDto {

    init(_data?: any) {
    }

    static fromJS(data: any): MissionAssignationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissionAssignationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export class GetAdvertisementTrackingListViewModel {
    items?: GetAdvertisementTrackingListAdvertisementDto[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAdvertisementTrackingListAdvertisementDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAdvertisementTrackingListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdvertisementTrackingListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class GetAdvertisementTrackingListAdvertisementDto {
    code?: string;
    doNotShowAgain?: boolean;

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.doNotShowAgain = _data["doNotShowAgain"];
        }
    }

    static fromJS(data: any): GetAdvertisementTrackingListAdvertisementDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdvertisementTrackingListAdvertisementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["doNotShowAgain"] = this.doNotShowAgain;
        return data;
    }
}

export class GetAdvertisementTrackingByCodeViewModel {
    doNotShowAgain?: boolean;

    init(_data?: any) {
        if (_data) {
            this.doNotShowAgain = _data["doNotShowAgain"];
        }
    }

    static fromJS(data: any): GetAdvertisementTrackingByCodeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdvertisementTrackingByCodeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doNotShowAgain"] = this.doNotShowAgain;
        return data;
    }
}

export class UpdateAdvertisementTrackingByCodeDto {
    doNotShowAgain?: boolean;

    init(_data?: any) {
        if (_data) {
            this.doNotShowAgain = _data["doNotShowAgain"];
        }
    }

    static fromJS(data: any): UpdateAdvertisementTrackingByCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAdvertisementTrackingByCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doNotShowAgain"] = this.doNotShowAgain;
        return data;
    }
}

export class GetNotificationSettingsViewModel {
    notificationSettings?: GetNotificationSettingsDto[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notificationSettings"])) {
                this.notificationSettings = [] as any;
                for (let item of _data["notificationSettings"])
                    this.notificationSettings!.push(GetNotificationSettingsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationSettingsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationSettingsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notificationSettings)) {
            data["notificationSettings"] = [];
            for (let item of this.notificationSettings)
                data["notificationSettings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class GetNotificationSettingsDto {
    subject?: MysteryShopperNotificationSubject;
    subjectTitle?: string;
    emailEnabled?: boolean;
    pushNotificationEnabled?: boolean;

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.subjectTitle = _data["subjectTitle"];
            this.emailEnabled = _data["emailEnabled"];
            this.pushNotificationEnabled = _data["pushNotificationEnabled"];
        }
    }

    static fromJS(data: any): GetNotificationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["subjectTitle"] = this.subjectTitle;
        data["emailEnabled"] = this.emailEnabled;
        data["pushNotificationEnabled"] = this.pushNotificationEnabled;
        return data;
    }
}

export enum MysteryShopperNotificationSubject {
    ExclusiveMarketingEmail = 0,
    ShowSimilarMissionsAfterMissionSuccess = 1,
    WeeklyMissionDigest = 2,
    LocalMissionBriefings = 3,
}

export class SaveNotificationSettingsRequest {
    subject?: MysteryShopperNotificationSubject;
    type?: MysteryShopperNotificationType;
    enabled?: boolean;

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.type = _data["type"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): SaveNotificationSettingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveNotificationSettingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["type"] = this.type;
        data["enabled"] = this.enabled;
        return data;
    }
}

export enum MysteryShopperNotificationType {
    Email = 0,
    PushNotification = 1,
}

export class QualityWarningSummaryResponse {
    activeWarning?: QualityWarningSummaryDto | undefined;

    init(_data?: any) {
        if (_data) {
            this.activeWarning = _data["activeWarning"] ? QualityWarningSummaryDto.fromJS(_data["activeWarning"]) : undefined as any;
        }
    }

    static fromJS(data: any): QualityWarningSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QualityWarningSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeWarning"] = this.activeWarning ? this.activeWarning.toJSON() : undefined as any;
        return data;
    }
}

export class SurveyImageUploadResponse {
    id?: string;
    name?: string;
    type?: string;
    content?: string;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): SurveyImageUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyImageUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["content"] = this.content;
        return data;
    }
}

export class GetTagsViewModel {
    tags?: GetTagsDto[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(GetTagsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTagsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetTagsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export class GetTagsDto {
    id?: string;
    text?: string;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): GetTagsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTagsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export class GetTransactionListViewModel {
    transactions?: TokenPaginatedResponseOfGetTransactionListTransactionDto;

    init(_data?: any) {
        if (_data) {
            this.transactions = _data["transactions"] ? TokenPaginatedResponseOfGetTransactionListTransactionDto.fromJS(_data["transactions"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTransactionListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactions"] = this.transactions ? this.transactions.toJSON() : undefined as any;
        return data;
    }
}

export class TokenPaginatedResponseOfGetTransactionListTransactionDto {
    items?: GetTransactionListTransactionDto[];
    pageSize?: number;
    continuationToken?: string | undefined;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTransactionListTransactionDto.fromJS(item));
            }
            this.pageSize = _data["pageSize"];
            this.continuationToken = _data["continuationToken"];
        }
    }

    static fromJS(data: any): TokenPaginatedResponseOfGetTransactionListTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TokenPaginatedResponseOfGetTransactionListTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageSize"] = this.pageSize;
        data["continuationToken"] = this.continuationToken;
        return data;
    }
}

export class GetTransactionListTransactionDto {
    id?: string;
    type?: GetTransactionListTransactionType;
    date?: Date;
    amountCurrency?: number;
    amountPoints?: number;
    balanceCurrency?: number;
    balancePoints?: number;
    reason?: string | undefined;
    missionAssignationId?: string | undefined;
    name?: string | undefined;
    missionConfigurationName?: string | undefined;
    hasLogo?: boolean;
    logoUrl?: string | undefined;
    branchAddress?: string | undefined;
    branchCity?: string | undefined;
    branchPostalCode?: string | undefined;
    branchGeocoordinate?: GeoLocation | undefined;
    branchId?: string | undefined;
    branchName?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.amountCurrency = _data["amountCurrency"];
            this.amountPoints = _data["amountPoints"];
            this.balanceCurrency = _data["balanceCurrency"];
            this.balancePoints = _data["balancePoints"];
            this.reason = _data["reason"];
            this.missionAssignationId = _data["missionAssignationId"];
            this.name = _data["name"];
            this.missionConfigurationName = _data["missionConfigurationName"];
            this.hasLogo = _data["hasLogo"];
            this.logoUrl = _data["logoUrl"];
            this.branchAddress = _data["branchAddress"];
            this.branchCity = _data["branchCity"];
            this.branchPostalCode = _data["branchPostalCode"];
            this.branchGeocoordinate = _data["branchGeocoordinate"] ? GeoLocation.fromJS(_data["branchGeocoordinate"]) : undefined as any;
            this.branchId = _data["branchId"];
            this.branchName = _data["branchName"];
        }
    }

    static fromJS(data: any): GetTransactionListTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionListTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["amountCurrency"] = this.amountCurrency;
        data["amountPoints"] = this.amountPoints;
        data["balanceCurrency"] = this.balanceCurrency;
        data["balancePoints"] = this.balancePoints;
        data["reason"] = this.reason;
        data["missionAssignationId"] = this.missionAssignationId;
        data["name"] = this.name;
        data["missionConfigurationName"] = this.missionConfigurationName;
        data["hasLogo"] = this.hasLogo;
        data["logoUrl"] = this.logoUrl;
        data["branchAddress"] = this.branchAddress;
        data["branchCity"] = this.branchCity;
        data["branchPostalCode"] = this.branchPostalCode;
        data["branchGeocoordinate"] = this.branchGeocoordinate ? this.branchGeocoordinate.toJSON() : undefined as any;
        data["branchId"] = this.branchId;
        data["branchName"] = this.branchName;
        return data;
    }
}

export enum GetTransactionListTransactionType {
    Unknown = 0,
    Adjustment = 1,
    Validation = 2,
    Mission = 3,
    CashOut = 4,
    MissionReferral = 5,
}

export class GetTransactionListFilter {
    transactionTypes?: GetTransactionListTransactionType[] | undefined;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["transactionTypes"])) {
                this.transactionTypes = [] as any;
                for (let item of _data["transactionTypes"])
                    this.transactionTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): GetTransactionListFilter {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionListFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.transactionTypes)) {
            data["transactionTypes"] = [];
            for (let item of this.transactionTypes)
                data["transactionTypes"].push(item);
        }
        return data;
    }
}

export class CanProceedToCashOutViewModel {
    status?: CanCashOutStatusType;
    cashOutTransactionId?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.cashOutTransactionId = _data["cashOutTransactionId"];
        }
    }

    static fromJS(data: any): CanProceedToCashOutViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CanProceedToCashOutViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["cashOutTransactionId"] = this.cashOutTransactionId;
        return data;
    }
}

export enum CanCashOutStatusType {
    Succeeded = 0,
    Refresh = 1,
    NoPoints = 2,
    NotEnoughPoints = 3,
    InProgress = 4,
    Failed = 5,
    AccountSetupRequired = 6,
}

export class ProceedToCashOutViewModel {
    status?: CanCashOutStatusType;
    cashOutTransactionId?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.cashOutTransactionId = _data["cashOutTransactionId"];
        }
    }

    static fromJS(data: any): ProceedToCashOutViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProceedToCashOutViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["cashOutTransactionId"] = this.cashOutTransactionId;
        return data;
    }
}

export class CancelCashOutViewModel {
    status?: CancelCashOutStatusType;

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CancelCashOutViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CancelCashOutViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}

export enum CancelCashOutStatusType {
    Succeeded = 0,
    AlreadyCancelled = 1,
    NoTransactionId = 2,
    PaymentCancelFailed = 3,
    CashInFailed = 4,
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' +
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}